import {
  __async,
  __objRest,
  __spreadProps,
  __spreadValues
} from "./chunk-RGHW4PYM.mjs";

// src/components/avatar/index.tsx
import clsx from "clsx";

// src/components/avatar/placeholder-avatar-organization.svg
var placeholder_avatar_organization_default = 'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="none">%0A    <path fill="%23F6F6F8" d="M0 0h40v40H0z" />%0A    <path%0A        d="M9.5 28.25h21M21.5 28.25v-16.5a.75.75 0 00-.75-.75h-9a.75.75 0 00-.75.75v16.5M29 28.25v-10.5a.75.75 0 00-.75-.75H21.5M14 14.75h3M15.5 20.75h3M14 24.5h3M24.5 24.5H26M24.5 20.75H26"%0A        stroke="%23282A30" stroke-linecap="round" stroke-linejoin="round" />%0A</svg>%0A';

// src/components/avatar/placeholder-avatar-user.svg
var placeholder_avatar_user_default = 'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="none">%0A    <rect width="40" height="40" fill="%23F6F6F8" />%0A    <path d="M20 23a6 6 0 100-12 6 6 0 000 12zM10.906 28.25a10.501 10.501 0 0118.188 0" stroke="%23282A30"%0A        stroke-linecap="round" stroke-linejoin="round" />%0A</svg>%0A';

// src/components/avatar/index.tsx
import { jsx } from "react/jsx-runtime";
function Avatar({
  avatar,
  className
}) {
  var _a;
  const fallbackUrl = avatar.kind === "organization" ? placeholder_avatar_organization_default : placeholder_avatar_user_default;
  const src = (_a = avatar.url) != null ? _a : fallbackUrl;
  return /* @__PURE__ */ jsx(
    "img",
    {
      "data-avatar-kind": avatar.kind,
      className: clsx("r8-avatar", className),
      src,
      alt: "",
      role: "presentation",
      onError: (e) => {
        e.currentTarget.onerror = null;
        e.currentTarget.src = fallbackUrl;
      }
    }
  );
}

// src/components/button/index.tsx
import {
  Button as AKButton
} from "@ariakit/react";
import { cva } from "class-variance-authority";
import { forwardRef as forwardRef2 } from "react";

// src/util.ts
import { clsx as clsx2 } from "clsx";
import { forwardRef } from "react";
function cn(...inputs) {
  return clsx2(inputs);
}
var fixedForwardRef = forwardRef;
function compactInteger(input, decimals = 0) {
  const safeDecimals = Math.max(decimals, 0);
  const number = typeof input === "number" ? input : Number.parseInt(input, 10);
  const signString = number < 0 ? "-" : "";
  const unsignedNumber = Math.abs(number);
  const unsignedNumberString = String(unsignedNumber);
  const numberLength = unsignedNumberString.length;
  const numberLengths = [13, 10, 7, 4];
  const bigNumPrefixes = ["T", "B", "M", "k"];
  if (unsignedNumber < 1e3) {
    return `${signString}${unsignedNumberString}`;
  }
  if (numberLength > numberLengths[0] + 3) {
    return number.toExponential(safeDecimals).replace("e+", "x10^");
  }
  let length = numberLengths[numberLengths.length - 1];
  for (let i = 0; i < numberLengths.length; i++) {
    const _length = numberLengths[i];
    if (numberLength >= _length) {
      length = _length;
      break;
    }
  }
  const decimalIndex = numberLength - length + 1;
  const unsignedNumberCharacterArray = unsignedNumberString.split("");
  const wholePartArray = unsignedNumberCharacterArray.slice(0, decimalIndex);
  const decimalPartArray = unsignedNumberCharacterArray.slice(
    decimalIndex,
    decimalIndex + safeDecimals + 1
  );
  const wholePart = wholePartArray.join("");
  let decimalPart = decimalPartArray.join("");
  if (decimalPart.length < safeDecimals) {
    decimalPart += `${Array(safeDecimals - decimalPart.length + 1).join("0")}`;
  }
  let output;
  if (safeDecimals === 0) {
    output = `${signString}${wholePart}${bigNumPrefixes[numberLengths.indexOf(length)]}`;
  } else {
    const outputNumber = Number(`${wholePart}.${decimalPart}`).toFixed(
      safeDecimals
    );
    output = `${signString}${outputNumber}${bigNumPrefixes[numberLengths.indexOf(length)]}`;
  }
  return output;
}

// src/components/spinner/index.tsx
import { jsx as jsx2, jsxs } from "react/jsx-runtime";
function Spinner() {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      className: "r8-spinner",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      children: [
        /* @__PURE__ */ jsx2(
          "circle",
          {
            style: {
              opacity: 0.25
            },
            cx: "12",
            cy: "12",
            r: "10",
            stroke: "currentColor",
            strokeWidth: "4"
          }
        ),
        /* @__PURE__ */ jsx2(
          "path",
          {
            style: {
              opacity: 0.75
            },
            fill: "currentColor",
            d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          }
        )
      ]
    }
  );
}

// src/components/button/index.tsx
import { jsx as jsx3, jsxs as jsxs2 } from "react/jsx-runtime";
var buttonCva = cva("r8-btn", {
  variants: {
    variant: {
      filled: "r8-btn--filled",
      outlined: "r8-btn--outlined",
      clear: "r8-btn--clear"
    },
    loading: {
      true: "r8-btn--disabled"
    },
    disabled: {
      true: "r8-btn--disabled"
    },
    intent: {
      primary: "r8-btn--primary",
      success: "r8-btn--success",
      danger: "r8-btn--danger",
      info: "r8-btn--info",
      warning: "r8-btn--warning",
      brand: "r8-btn--brand"
    },
    underlined: {
      true: "r8-btn--link"
    },
    round: {
      true: "r8-btn--round"
    },
    size: {
      xs: "r8-btn--xs",
      sm: "r8-btn--sm",
      md: "r8-btn--md",
      lg: "r8-btn--lg"
    }
  }
});
var Button = forwardRef2(
  (_a, ref) => {
    var _b = _a, {
      variant = "filled",
      intent = "primary",
      size = "md",
      startIcon,
      endIcon,
      round,
      underlined,
      disabled,
      loading,
      children,
      className
    } = _b, rest = __objRest(_b, [
      "variant",
      "intent",
      "size",
      "startIcon",
      "endIcon",
      "round",
      "underlined",
      "disabled",
      "loading",
      "children",
      "className"
    ]);
    const btnClassName = cn(
      buttonCva({
        variant,
        intent,
        size,
        round,
        underlined,
        loading,
        disabled,
        className
      })
    );
    if (loading) {
      startIcon = /* @__PURE__ */ jsx3(Spinner, {});
      endIcon = null;
    }
    return /* @__PURE__ */ jsxs2(
      AKButton,
      __spreadProps(__spreadValues({}, rest), {
        ref,
        disabled: disabled || loading,
        className: btnClassName,
        children: [
          startIcon ? /* @__PURE__ */ jsx3("span", { className: "r8-btn__icon", children: startIcon }) : null,
          children,
          endIcon ? /* @__PURE__ */ jsx3("span", { className: "r8-btn__icon", children: endIcon }) : null
        ]
      })
    );
  }
);
Button.displayName = "Button";
var IconButton = forwardRef2(
  (_a, ref) => {
    var _b = _a, {
      variant = "filled",
      intent = "primary",
      size = "md",
      loading,
      disabled,
      className,
      children
    } = _b, rest = __objRest(_b, [
      "variant",
      "intent",
      "size",
      "loading",
      "disabled",
      "className",
      "children"
    ]);
    const btnClassName = cn(
      buttonCva({
        variant,
        intent,
        size,
        loading,
        disabled,
        className: `r8-btn--icon ${className}`
      })
    );
    return /* @__PURE__ */ jsx3(
      AKButton,
      __spreadProps(__spreadValues({}, rest), {
        disabled,
        className: btnClassName,
        ref,
        children: /* @__PURE__ */ jsx3("span", { className: "r8-btn__icon", children: loading ? /* @__PURE__ */ jsx3(Spinner, {}) : children })
      })
    );
  }
);
IconButton.displayName = "IconButton";

// src/components/banner/index.tsx
import { X } from "@phosphor-icons/react";
import { forwardRef as forwardRef3 } from "react";

// src/variants.ts
import { cva as cva2 } from "class-variance-authority";
var formGroup = cva2("r8-form-group", {
  variants: {
    size: {
      sm: "r8-form-group--sm",
      md: "r8-form-group--md",
      lg: "r8-form-group--lg"
    },
    variant: {
      error: "r8-form-group--error"
    }
  }
});
var tabs = cva2("r8-tabs", {
  variants: {
    variant: {
      bordered: "r8-tabs--bordered",
      segmented: "r8-tabs--segmented",
      pills: "r8-tabs--pills"
    },
    size: {
      sm: "r8-tabs--sm",
      md: "r8-tabs--md"
    }
  },
  defaultVariants: {
    variant: "bordered",
    size: "md"
  }
});
var badge = cva2("r8-badge", {
  variants: {
    variant: {
      default: "r8-badge--default",
      warning: "r8-badge--warning",
      accent: "r8-badge--accent",
      danger: "r8-badge--danger",
      success: "r8-badge--success"
    },
    size: {
      sm: "r8-badge--sm",
      md: "r8-badge--md"
    }
  },
  defaultVariants: {
    variant: "default"
  }
});
var box = cva2("r8-box", {
  variants: {
    variant: {
      card: "r8-box--card",
      default: "r8-box--default",
      "tinted-frame": "r8-box--tinted-frame",
      well: "r8-box--well"
    }
  },
  defaultVariants: {
    variant: "default"
  }
});
var selectItem = cva2("r8-select__item", {
  variants: {
    intent: {
      default: "r8-select__item--default",
      danger: "r8-select__item--danger"
    }
  },
  defaultVariants: {
    intent: "default"
  }
});
var dialog = cva2("r8-dialog", {
  variants: {
    variant: {
      default: "r8-dialog--default",
      drawer: "r8-dialog--drawer"
    },
    side: {
      left: "r8-dialog--drawer-left",
      right: "r8-dialog--drawer-right",
      bottom: "r8-dialog--drawer-bottom",
      top: "r8-dialog--drawer-top"
    },
    size: {
      sm: "r8-dialog--sm",
      md: "r8-dialog--md",
      lg: "r8-dialog--lg",
      xl: "r8-dialog--xl"
    }
  },
  defaultVariants: {
    variant: "default",
    side: "right",
    size: "md"
  }
});
var banner = cva2("r8-banner", {
  variants: {
    severity: {
      default: "r8-banner--default",
      info: "r8-banner--info",
      warning: "r8-banner--warning",
      error: "r8-banner--error",
      success: "r8-banner--success"
    }
  },
  defaultVariants: {
    severity: "default"
  }
});

// src/components/banner/index.tsx
import { jsx as jsx4, jsxs as jsxs3 } from "react/jsx-runtime";
var Banner = forwardRef3(
  (_a, ref) => {
    var _b = _a, {
      severity = "default",
      icon,
      heading,
      description,
      meta,
      dismissible,
      onDismiss,
      condensed = false,
      raised = false,
      fullWidth = false,
      flushTop = false,
      centered = false
    } = _b, rest = __objRest(_b, [
      "severity",
      "icon",
      "heading",
      "description",
      "meta",
      "dismissible",
      "onDismiss",
      "condensed",
      "raised",
      "fullWidth",
      "flushTop",
      "centered"
    ]);
    const bannerClassName = cn(
      banner({
        severity
      }),
      {
        "r8-banner--condensed": condensed,
        "r8-banner--raised": raised,
        "r8-banner--full-width": fullWidth,
        "r8-banner--flush-top": flushTop,
        "r8-banner--centered": centered
      }
    );
    return /* @__PURE__ */ jsxs3("div", __spreadProps(__spreadValues({ ref, className: bannerClassName }, rest), { children: [
      dismissible && /* @__PURE__ */ jsx4(
        "button",
        {
          type: "button",
          onClick: () => {
            onDismiss == null ? void 0 : onDismiss();
          },
          className: "r8-banner--dismissible",
          children: /* @__PURE__ */ jsx4(X, { weight: "bold" })
        }
      ),
      icon && /* @__PURE__ */ jsx4("div", { className: "r8-banner__icon", children: icon }),
      /* @__PURE__ */ jsxs3("div", { className: "r8-banner__body", children: [
        /* @__PURE__ */ jsxs3("div", { className: "r8-banner__copy", children: [
          heading ? /* @__PURE__ */ jsx4("div", { className: "r8-banner--heading", children: heading }) : null,
          /* @__PURE__ */ jsx4("div", { className: "r8-banner--description", children: description })
        ] }),
        meta ? /* @__PURE__ */ jsx4("div", { className: "r8-banner__meta", children: meta }) : null
      ] })
    ] }));
  }
);

// src/components/checkbox/index.tsx
import {
  Checkbox as AKCheckbox,
  useCheckboxStore,
  useCheckboxContext,
  CheckboxProvider
} from "@ariakit/react";
import { jsx as jsx5 } from "react/jsx-runtime";
var Checkbox = fixedForwardRef((props, ref) => {
  return /* @__PURE__ */ jsx5(
    AKCheckbox,
    __spreadProps(__spreadValues({
      className: cn("r8-checkbox", props.className)
    }, props), {
      ref
    })
  );
});

// src/components/dashboard-navigation/index.tsx
import { useMemo } from "react";

// src/components/site-navigation/util.tsx
import {
  GraduationCap,
  Lightning,
  Plus,
  WebhooksLogo,
  Question,
  Rocket,
  BookOpen,
  CubeFocus,
  Sparkle,
  Star
} from "@phosphor-icons/react";
import React from "react";
import { jsx as jsx6 } from "react/jsx-runtime";
var LinksObjectData = {
  dashboard: {
    label: "Dashboard",
    href: "/dashboard",
    primary: true,
    matchPatterns: ["/dashboard/*"]
  },
  signup: {
    label: "Try for free",
    href: "/signin",
    primary: true,
    icon: /* @__PURE__ */ jsx6(Lightning, { size: 18 })
  },
  signin: {
    label: "Sign in",
    href: "/signin"
  },
  explore: {
    label: "Explore",
    href: "/explore"
  },
  pricing: {
    label: "Pricing",
    href: "/pricing"
  },
  docs: {
    label: "Docs",
    href: "/docs",
    matchPatterns: ["/docs/*"]
  },
  enterprise: {
    label: "Enterprise",
    href: "/enterprise"
  },
  blog: {
    label: "Blog",
    href: "/blog",
    matchPatterns: ["/blog/*"]
  },
  changelog: {
    label: "Changelog",
    href: "/changelog",
    matchPatterns: ["/changelog/*"]
  },
  playground: {
    label: "Playground",
    href: "/playground"
  },
  create: {
    label: "Create a model",
    href: "/create",
    icon: /* @__PURE__ */ jsx6(Plus, { size: 18 })
  }
};
var Links = LinksObjectData;
var DashboardLinksObjectData = {
  dashboard: {
    label: "Dashboard",
    description: "View your Replicate dashboard",
    href: "/dashboard",
    icon: /* @__PURE__ */ jsx6(BookOpen, { size: 18 })
  },
  models: {
    label: "Models",
    description: "View and run your models",
    href: "/models",
    icon: /* @__PURE__ */ jsx6(CubeFocus, { size: 18 })
  },
  predictions: {
    label: "Predictions",
    description: "Review predictions you've run",
    href: "/predictions",
    icon: /* @__PURE__ */ jsx6(Sparkle, { size: 18 })
  },
  trainings: {
    label: "Trainings",
    description: "Models you've created from datasets like images",
    href: "/trainings",
    icon: /* @__PURE__ */ jsx6(GraduationCap, { size: 18 })
  },
  deployments: {
    label: "Deployments",
    description: "Your private models in the cloud",
    href: "/deployments",
    icon: /* @__PURE__ */ jsx6(Rocket, { size: 18 })
  },
  webhooks: {
    label: "Webhooks",
    description: "Review webhooks for your predictions",
    href: "/webhooks",
    icon: /* @__PURE__ */ jsx6(WebhooksLogo, { size: 18 })
  },
  support: {
    label: "Support",
    description: "Reach out to the Replicate team",
    href: "/support",
    icon: /* @__PURE__ */ jsx6(Question, { size: 18 })
  },
  stars: {
    label: "Stars",
    description: "View your starred models",
    href: "/stars",
    icon: /* @__PURE__ */ jsx6(Star, { size: 18 })
  }
};
var DashboardLinks = DashboardLinksObjectData;
function isItemActive(item, currentPath) {
  var _a;
  if (item.href === currentPath) return true;
  if (item.href === "/dashboard" && currentPath === "/") return true;
  if (currentPath.startsWith(`${item.href}/`) && item.href !== "/") return true;
  if ((_a = item.matchPatterns) == null ? void 0 : _a.some((pattern) => {
    if (pattern.includes("*")) {
      const regex = new RegExp(`^${pattern.replace(/\*/g, ".*")}$`);
      return regex.test(currentPath);
    }
    return currentPath.startsWith(pattern);
  }))
    return true;
  return false;
}
function createLinkRender({
  item,
  currentPath,
  anchorProps,
  renderLink,
  additionalProps = {}
}) {
  const isActive = isItemActive(item, currentPath);
  const baseProps = __spreadValues(__spreadValues({
    href: item.href,
    "data-active": isActive
  }, anchorProps(item)), additionalProps);
  if (renderLink) {
    return (props) => {
      const _a = props, { key } = _a, propsWithoutKey = __objRest(_a, ["key"]);
      const domSafeProps = Object.fromEntries(
        Object.entries(__spreadValues(__spreadValues({}, baseProps), propsWithoutKey)).filter(
          ([key2]) => !["isActive", "label", "children"].includes(key2)
        )
      );
      return /* @__PURE__ */ jsx6(React.Fragment, { children: renderLink(__spreadValues({
        // Metadata (not for spreading)
        href: item.href,
        isActive,
        label: item.label,
        children: propsWithoutKey.children
      }, domSafeProps)) }, key);
    };
  }
  return (props) => {
    const _a = props, { key } = _a, propsWithoutKey = __objRest(_a, ["key"]);
    return /* @__PURE__ */ jsx6("a", __spreadValues(__spreadValues({}, baseProps), propsWithoutKey));
  };
}

// src/components/tabs/index.tsx
import {
  Tab as AKTab,
  TabList as AKTabList,
  TabPanel as AKTabPanel,
  TabProvider,
  useTabContext,
  useTabStore
} from "@ariakit/react";
import {
  useEffect,
  useRef,
  useState
} from "react";
import { List } from "@phosphor-icons/react";
import { jsx as jsx7, jsxs as jsxs4 } from "react/jsx-runtime";
function ResponsiveTabList(props) {
  var _b;
  const _a = props, { children } = _a, rest = __objRest(_a, ["children"]);
  const [overflowing, setOverflowing] = useState(false);
  const tabsContainerRef = useRef(null);
  const context = useTabContext();
  if (!context)
    throw new Error("ResponsiveTabList must be used inside a TabProvider");
  const activeId = context.useState((state) => state.activeId);
  useEffect(() => {
    const tabsContainer = tabsContainerRef.current;
    const checkOverflow = () => {
      if (tabsContainer) {
        if (tabsContainer.scrollWidth > tabsContainer.clientWidth) {
          setOverflowing(true);
        } else {
          setOverflowing(false);
        }
      }
    };
    checkOverflow();
    window.addEventListener("resize", checkOverflow);
    return () => {
      window.removeEventListener("resize", checkOverflow);
    };
  }, []);
  if (!Array.isArray(children)) return;
  const flattened = children.filter(Boolean).flatMap((child) => {
    var _a2;
    if (Array.isArray((_a2 = child == null ? void 0 : child.props) == null ? void 0 : _a2.children)) {
      return child.props.children;
    }
    return child;
  }).filter(Boolean);
  const activeTab = flattened.find((tab) => {
    var _a2;
    return ((_a2 = tab == null ? void 0 : tab.props) == null ? void 0 : _a2.id) === activeId;
  });
  const activeIcon = (_b = activeTab == null ? void 0 : activeTab.props) == null ? void 0 : _b.startIcon;
  return /* @__PURE__ */ jsxs4("div", { className: "r8-tabs--responsive-grid", children: [
    /* @__PURE__ */ jsx7(
      "div",
      {
        "aria-hidden": overflowing,
        className: "r8-tabs--responsive-tab-list-wrap",
        style: {
          opacity: overflowing ? 0 : 1,
          pointerEvents: overflowing ? "none" : "auto"
        },
        ref: tabsContainerRef,
        children: /* @__PURE__ */ jsx7(TabList, __spreadProps(__spreadValues({}, rest), { children: flattened.map((child) => {
          return child;
        }) }))
      }
    ),
    overflowing && /* @__PURE__ */ jsxs4("div", { className: "r8-tabs--responsive-select-wrap", children: [
      /* @__PURE__ */ jsx7("span", { className: "r8-tabs--responsive-select-icon", children: activeIcon || /* @__PURE__ */ jsx7(List, { weight: "bold", size: 16 }) }),
      /* @__PURE__ */ jsx7(
        "select",
        {
          value: activeId != null ? activeId : void 0,
          onChange: (e) => {
            context.setSelectedId(e.target.value);
          },
          className: "r8-tabs--responsive-select",
          children: flattened.map((tab) => {
            var _a2, _b2, _c, _d, _e;
            if (!((_a2 = tab == null ? void 0 : tab.props) == null ? void 0 : _a2.id)) return null;
            if (!((_b2 = tab == null ? void 0 : tab.props) == null ? void 0 : _b2.children)) return null;
            return /* @__PURE__ */ jsx7("option", { value: (_d = tab.props) == null ? void 0 : _d.id, children: (_e = tab.props) == null ? void 0 : _e.children }, (_c = tab.props) == null ? void 0 : _c.id);
          })
        }
      )
    ] })
  ] });
}
function DashboardTabList(props) {
  var _b;
  const _a = props, { children, onSelectChange, navigationItems } = _a, rest = __objRest(_a, ["children", "onSelectChange", "navigationItems"]);
  const [overflowing, setOverflowing] = useState(false);
  const tabsContainerRef = useRef(null);
  const context = useTabContext();
  if (!context)
    throw new Error("DashboardTabList must be used inside a TabProvider");
  const activeId = context.useState((state) => state.activeId);
  useEffect(() => {
    const tabsContainer = tabsContainerRef.current;
    const checkOverflow = () => {
      if (tabsContainer) {
        if (tabsContainer.scrollWidth > tabsContainer.clientWidth) {
          setOverflowing(true);
        } else {
          setOverflowing(false);
        }
      }
    };
    checkOverflow();
    window.addEventListener("resize", checkOverflow);
    return () => {
      window.removeEventListener("resize", checkOverflow);
    };
  }, []);
  if (!Array.isArray(children)) return;
  const flattened = children.filter(Boolean).flatMap((child) => {
    var _a2;
    if (Array.isArray((_a2 = child == null ? void 0 : child.props) == null ? void 0 : _a2.children)) {
      return child.props.children;
    }
    return child;
  }).filter(Boolean);
  const activeTab = flattened.find((tab) => {
    var _a2;
    return ((_a2 = tab == null ? void 0 : tab.props) == null ? void 0 : _a2.id) === activeId;
  });
  const activeIcon = (_b = activeTab == null ? void 0 : activeTab.props) == null ? void 0 : _b.startIcon;
  return /* @__PURE__ */ jsxs4("div", { className: "r8-tabs--responsive-grid", children: [
    /* @__PURE__ */ jsx7(
      "div",
      {
        "aria-hidden": overflowing,
        className: "r8-tabs--responsive-tab-list-wrap",
        style: {
          opacity: overflowing ? 0 : 1,
          pointerEvents: overflowing ? "none" : "auto"
        },
        ref: tabsContainerRef,
        children: /* @__PURE__ */ jsx7(TabList, __spreadProps(__spreadValues({}, rest), { children: flattened.map((child) => {
          return child;
        }) }))
      }
    ),
    overflowing && /* @__PURE__ */ jsxs4("div", { className: "r8-tabs--responsive-select-wrap", children: [
      /* @__PURE__ */ jsx7("span", { className: "r8-tabs--responsive-select-icon", children: activeIcon || /* @__PURE__ */ jsx7(List, { weight: "bold", size: 16 }) }),
      /* @__PURE__ */ jsx7(
        "select",
        {
          value: activeId != null ? activeId : void 0,
          onChange: (e) => {
            const item = navigationItems == null ? void 0 : navigationItems.find(
              (item2) => item2.label.toLowerCase() === e.target.value
            );
            if (!item) return;
            onSelectChange == null ? void 0 : onSelectChange(item.href);
          },
          className: "r8-tabs--responsive-select",
          children: flattened.map((tab) => {
            var _a2, _b2, _c, _d, _e;
            if (!((_a2 = tab == null ? void 0 : tab.props) == null ? void 0 : _a2.id)) return null;
            if (!((_b2 = tab == null ? void 0 : tab.props) == null ? void 0 : _b2.children)) return null;
            return /* @__PURE__ */ jsx7("option", { value: (_d = tab.props) == null ? void 0 : _d.id, children: (_e = tab.props) == null ? void 0 : _e.children }, (_c = tab.props) == null ? void 0 : _c.id);
          })
        }
      )
    ] })
  ] });
}
var TabList = fixedForwardRef(
  (_a, ref) => {
    var _b = _a, { size, variant, className, responsive } = _b, rest = __objRest(_b, ["size", "variant", "className", "responsive"]);
    const listClass = cn(tabs({ size, variant }), className);
    if (responsive)
      return /* @__PURE__ */ jsx7(ResponsiveTabList, __spreadValues({ className: listClass }, rest));
    return /* @__PURE__ */ jsx7(AKTabList, __spreadProps(__spreadValues({ className: listClass }, rest), { ref }));
  }
);
var Tab = fixedForwardRef(
  (_a, ref) => {
    var _b = _a, { className, startIcon, badge: badge2, children } = _b, rest = __objRest(_b, ["className", "startIcon", "badge", "children"]);
    return /* @__PURE__ */ jsxs4(AKTab, __spreadProps(__spreadValues({ className: cn("r8-tabs__tab", className) }, rest), { ref, children: [
      startIcon && /* @__PURE__ */ jsx7("span", { className: "r8-tabs__start-icon", children: startIcon }),
      /* @__PURE__ */ jsx7("span", { children }),
      badge2 && /* @__PURE__ */ jsx7("span", { className: "r8-tabs__badge", children: badge2 })
    ] }));
  }
);
var TabPanel = fixedForwardRef(
  (_a, ref) => {
    var _b = _a, { className } = _b, rest = __objRest(_b, ["className"]);
    return /* @__PURE__ */ jsx7(
      AKTabPanel,
      __spreadProps(__spreadValues({
        className: cn("r8-tabs__content", className)
      }, rest), {
        ref
      })
    );
  }
);

// src/components/dashboard-navigation/index.tsx
import { jsx as jsx8 } from "react/jsx-runtime";
function DashboardNavigation({
  currentPath,
  renderLink,
  kind,
  username,
  anchorProps = () => ({}),
  onSelectChange
}) {
  const navigationItems = useMemo(() => {
    const items = [
      DashboardLinks.dashboard,
      DashboardLinks.models,
      DashboardLinks.predictions,
      DashboardLinks.trainings,
      DashboardLinks.deployments,
      DashboardLinks.webhooks
    ];
    if (kind === "user") {
      items.push(__spreadProps(__spreadValues({}, DashboardLinks.stars), {
        href: `/${username}/stars`
      }));
    }
    items.push(DashboardLinks.support);
    return items;
  }, [kind, username]);
  const selectedId = useMemo(() => {
    if (currentPath === "/") {
      return "dashboard";
    }
    const matchingItem = navigationItems.find(
      (item) => item.href === currentPath || currentPath.startsWith(`${item.href}/`)
    );
    if (matchingItem) {
      return matchingItem.label.toLowerCase();
    }
    return null;
  }, [currentPath, navigationItems]);
  return /* @__PURE__ */ jsx8(TabProvider, { selectedId, children: /* @__PURE__ */ jsx8(
    DashboardTabList,
    {
      navigationItems,
      onSelectChange,
      children: navigationItems.map((item) => /* @__PURE__ */ jsx8(
        Tab,
        {
          id: item.label.toLowerCase(),
          render: createLinkRender({
            item,
            currentPath,
            renderLink,
            anchorProps
          }),
          startIcon: item.icon,
          children: item.label
        },
        item.label
      ))
    }
  ) });
}

// src/components/label/index.tsx
import { cva as cva3 } from "class-variance-authority";
import { forwardRef as forwardRef4 } from "react";
import { jsx as jsx9 } from "react/jsx-runtime";
var labelCva = cva3("r8-label", {
  variants: {
    variant: {
      mono: "r8-label--mono"
    }
  }
});
var Label = forwardRef4(
  (_a, ref) => {
    var _b = _a, { variant, className } = _b, rest = __objRest(_b, ["variant", "className"]);
    const labelClass = labelCva({ variant, className });
    return /* @__PURE__ */ jsx9("label", __spreadProps(__spreadValues({}, rest), { className: labelClass, ref }));
  }
);
Label.displayName = "Label";

// src/components/glyph-loader/glyph-loader.gif
var glyph_loader_default = "data:image/gif;base64,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";

// src/components/glyph-loader/index.tsx
import { jsx as jsx10, jsxs as jsxs5 } from "react/jsx-runtime";
function GlyphLoader({
  screenReaderLabel
}) {
  return /* @__PURE__ */ jsxs5("div", { role: "status", className: "r8-glyph-loader", children: [
    screenReaderLabel ? /* @__PURE__ */ jsx10("span", { className: "sr-only", children: screenReaderLabel }) : null,
    /* @__PURE__ */ jsx10("img", { className: "r8-glyph-loader-img", src: glyph_loader_default })
  ] });
}

// src/components/select/index.tsx
import {
  Select as AKSelect,
  SelectGroup as AKSelectGroup,
  SelectGroupLabel as AKSelectGroupLabel,
  SelectItem as AKSelectItem,
  SelectItemCheck as AKSelectItemCheck,
  SelectList as AKSelectList,
  SelectPopover as AKSelectPopover,
  SelectRow as AKSelectRow,
  SelectProvider,
  useSelectContext,
  useSelectStore,
  SelectLabel
} from "@ariakit/react";
import { Check } from "@phosphor-icons/react";
import { jsx as jsx11 } from "react/jsx-runtime";
var Select = fixedForwardRef(
  (_a, ref) => {
    var _b = _a, { className } = _b, rest = __objRest(_b, ["className"]);
    return /* @__PURE__ */ jsx11(AKSelect, __spreadProps(__spreadValues({}, rest), { className: cn("r8-select", className), ref }));
  }
);
var SelectPopover = fixedForwardRef((_a, ref) => {
  var _b = _a, { children, className } = _b, rest = __objRest(_b, ["children", "className"]);
  return /* @__PURE__ */ jsx11(
    AKSelectPopover,
    __spreadProps(__spreadValues({
      className: cn("r8-popover", className)
    }, rest), {
      getAnchorRect: (el) => {
        var _a2, _b2;
        const inFormGroup = (_a2 = el == null ? void 0 : el.parentElement) == null ? void 0 : _a2.classList.contains(
          "r8-form-group__input"
        );
        if (inFormGroup) {
          const parentFormGroup = el == null ? void 0 : el.closest(".r8-form-group__control");
          return (_b2 = parentFormGroup == null ? void 0 : parentFormGroup.getBoundingClientRect()) != null ? _b2 : el == null ? void 0 : el.getBoundingClientRect();
        }
        return el == null ? void 0 : el.getBoundingClientRect();
      },
      ref,
      children
    })
  );
});
var SelectItem = fixedForwardRef((_a, ref) => {
  var _b = _a, { className, intent } = _b, rest = __objRest(_b, ["className", "intent"]);
  const itemClass = cn(selectItem({ intent, className }));
  return /* @__PURE__ */ jsx11(AKSelectItem, __spreadProps(__spreadValues({ className: itemClass }, rest), { ref }));
});
var SelectGroup = fixedForwardRef((_a, ref) => {
  var _b = _a, { children, className } = _b, rest = __objRest(_b, ["children", "className"]);
  return /* @__PURE__ */ jsx11(
    AKSelectGroup,
    __spreadProps(__spreadValues({
      className: cn("r8-select__group", className)
    }, rest), {
      ref,
      children
    })
  );
});
var SelectGroupLabel = fixedForwardRef((_a, ref) => {
  var _b = _a, { children, className } = _b, rest = __objRest(_b, ["children", "className"]);
  return /* @__PURE__ */ jsx11(
    AKSelectGroupLabel,
    __spreadProps(__spreadValues({
      className: cn("r8-select__group-label", className)
    }, rest), {
      ref,
      children
    })
  );
});
var SelectItemCheck = fixedForwardRef((_a, ref) => {
  var _b = _a, { className } = _b, rest = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx11(
    AKSelectItemCheck,
    __spreadProps(__spreadValues({
      className: cn("r8-select__item-check", className)
    }, rest), {
      ref,
      children: /* @__PURE__ */ jsx11(Check, { weight: "bold" })
    })
  );
});
var SelectRow = fixedForwardRef((_a, ref) => {
  var _b = _a, { className } = _b, rest = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx11(
    AKSelectRow,
    __spreadProps(__spreadValues({
      className: cn("r8-select__row", className)
    }, rest), {
      ref
    })
  );
});
var SelectList = fixedForwardRef((_a, ref) => {
  var _b = _a, { className } = _b, rest = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx11(
    AKSelectList,
    __spreadProps(__spreadValues({
      className: cn("r8-select__list", className)
    }, rest), {
      ref
    })
  );
});

// src/components/popover/index.tsx
import {
  Popover as AKPopover,
  PopoverAnchor as AKPopoverAnchor,
  PopoverArrow as AKPopoverArrow,
  PopoverDisclosure as AKPopoverDisclosure,
  PopoverDismiss,
  PopoverDescription,
  PopoverHeading,
  PopoverProvider,
  usePopoverContext,
  usePopoverStore
} from "@ariakit/react";
import { jsx as jsx12 } from "react/jsx-runtime";
var PopoverAnchor = fixedForwardRef((props, ref) => {
  return /* @__PURE__ */ jsx12(AKPopoverAnchor, __spreadProps(__spreadValues({}, props), { ref }));
});
var PopoverArrow = fixedForwardRef((_a, ref) => {
  var _b = _a, { className } = _b, rest = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx12(
    AKPopoverArrow,
    __spreadProps(__spreadValues({
      className: cn("r8-popover__arrow", className)
    }, rest), {
      ref
    })
  );
});
var Popover = fixedForwardRef((_a, ref) => {
  var _b = _a, { children, className } = _b, rest = __objRest(_b, ["children", "className"]);
  return /* @__PURE__ */ jsx12(AKPopover, __spreadProps(__spreadValues({ className: cn("r8-popover", className) }, rest), { ref, children }));
});
var PopoverDisclosure = fixedForwardRef((_a, ref) => {
  var _b = _a, { className } = _b, rest = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx12(
    AKPopoverDisclosure,
    __spreadProps(__spreadValues({
      className: cn("r8-popover__disclosure", className)
    }, rest), {
      ref
    })
  );
});

// src/components/dialog/index.tsx
import {
  Dialog as AKDialog,
  DialogDescription as AKDialogDescription,
  DialogDisclosure as AKDialogDisclosure,
  DialogDismiss,
  DialogHeading as AKDialogHeading,
  DialogProvider,
  useDialogContext,
  useDialogStore
} from "@ariakit/react";
import { jsx as jsx13 } from "react/jsx-runtime";
var Dialog = fixedForwardRef((_a, ref) => {
  var _b = _a, { className, side, variant, size } = _b, rest = __objRest(_b, ["className", "side", "variant", "size"]);
  const dialogClass = cn(dialog({ variant, side, size, className }));
  const backdropclass = cn("r8-backdrop");
  return /* @__PURE__ */ jsx13(
    AKDialog,
    __spreadProps(__spreadValues({
      backdrop: /* @__PURE__ */ jsx13("div", { className: backdropclass }),
      className: dialogClass
    }, rest), {
      ref
    })
  );
});
var DialogDisclosure = fixedForwardRef((_a, ref) => {
  var _b = _a, { className } = _b, rest = __objRest(_b, ["className"]);
  if (!dialog)
    throw new Error("DialogDisclosure must be used within a DialogProvider");
  return /* @__PURE__ */ jsx13(
    AKDialogDisclosure,
    __spreadProps(__spreadValues({
      className: cn("r8-dialog__trigger", className)
    }, rest), {
      ref
    })
  );
});
var DialogHeading = fixedForwardRef((_a, ref) => {
  var _b = _a, { className } = _b, rest = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx13(
    AKDialogHeading,
    __spreadProps(__spreadValues({
      className: cn("r8-dialog__heading", className)
    }, rest), {
      ref
    })
  );
});
var DialogDescription = fixedForwardRef((_a, ref) => {
  var _b = _a, { className } = _b, rest = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx13(
    AKDialogDescription,
    __spreadProps(__spreadValues({
      className: cn("r8-dialog__description", className)
    }, rest), {
      ref
    })
  );
});

// src/components/menu/index.tsx
import {
  Menu as AKMenu,
  MenuButton as AKMenuButton,
  MenuGroup as AKMenuGroup,
  MenuGroupLabel as AKMenuGroupLabel,
  MenuItem as AKMenuItem,
  MenuItemCheck as AKMenuItemCheck,
  MenuItemCheckbox as AKMenuItemCheckbox,
  MenuItemRadio as AKMenuItemRadio,
  MenuList as AKMenuList,
  MenuSeparator as AKMenuSeparator,
  MenuProvider,
  useMenuStore,
  useMenuContext
} from "@ariakit/react";
import { Check as Check2 } from "@phosphor-icons/react";
import { jsx as jsx14 } from "react/jsx-runtime";
var Menu = fixedForwardRef(
  (_a, ref) => {
    var _b = _a, { className } = _b, rest = __objRest(_b, ["className"]);
    const menuClass = cn("r8-popover", className);
    return /* @__PURE__ */ jsx14(AKMenu, __spreadProps(__spreadValues({}, rest), { className: menuClass, ref }));
  }
);
var MenuButton = fixedForwardRef((props, ref) => {
  return /* @__PURE__ */ jsx14(AKMenuButton, __spreadProps(__spreadValues({}, props), { ref }));
});
var MenuItem = fixedForwardRef((_a, ref) => {
  var _b = _a, { intent, className } = _b, rest = __objRest(_b, ["intent", "className"]);
  const itemClass = cn(selectItem({ intent, className }));
  return /* @__PURE__ */ jsx14(AKMenuItem, __spreadProps(__spreadValues({ className: itemClass }, rest), { ref }));
});
var MenuSeparator = fixedForwardRef((props, ref) => {
  return /* @__PURE__ */ jsx14(
    AKMenuSeparator,
    __spreadProps(__spreadValues({
      className: cn("r8-select__separator", props.className)
    }, props), {
      ref
    })
  );
});
var MenuItemCheckbox = fixedForwardRef(function MenuItemCheckbox2(_a, ref) {
  var _b = _a, { className } = _b, rest = __objRest(_b, ["className"]);
  const itemClass = cn(selectItem({ className }));
  return /* @__PURE__ */ jsx14(AKMenuItemCheckbox, __spreadProps(__spreadValues({ ref }, rest), { className: itemClass }));
});
var MenuItemCheck = fixedForwardRef(function MenuItemCheck2(_a, ref) {
  var _b = _a, { className } = _b, rest = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx14(
    AKMenuItemCheck,
    __spreadProps(__spreadValues({
      className: cn("r8-select__item-check", className),
      ref
    }, rest), {
      children: /* @__PURE__ */ jsx14(Check2, { weight: "bold" })
    })
  );
});
var MenuGroup = fixedForwardRef((_a, ref) => {
  var _b = _a, { children, className } = _b, rest = __objRest(_b, ["children", "className"]);
  return /* @__PURE__ */ jsx14(
    AKMenuGroup,
    __spreadProps(__spreadValues({
      className: cn("r8-select__group", className)
    }, rest), {
      ref,
      children
    })
  );
});
var MenuGroupLabel = fixedForwardRef((_a, ref) => {
  var _b = _a, { children, className } = _b, rest = __objRest(_b, ["children", "className"]);
  return /* @__PURE__ */ jsx14(
    AKMenuGroupLabel,
    __spreadProps(__spreadValues({
      className: cn("r8-select__group-label", className)
    }, rest), {
      ref,
      children
    })
  );
});
var MenuList = fixedForwardRef((_a, ref) => {
  var _b = _a, { className } = _b, rest = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx14(
    AKMenuList,
    __spreadProps(__spreadValues({
      className: cn("r8-select__list", className)
    }, rest), {
      ref
    })
  );
});
var MenuItemRadio = fixedForwardRef(function MenuItemCheckbox3(_a, ref) {
  var _b = _a, { className } = _b, rest = __objRest(_b, ["className"]);
  const itemClass = cn(selectItem({ className }));
  return /* @__PURE__ */ jsx14(AKMenuItemRadio, __spreadProps(__spreadValues({ ref }, rest), { className: itemClass }));
});

// src/components/combobox/index.tsx
import {
  Combobox as AKCombobox,
  ComboboxGroup as AKComboboxGroup,
  ComboboxGroupLabel as AKComboboxGroupLabel,
  ComboboxItem as AKComboboxItem,
  ComboboxList as AKComboboxList,
  ComboboxPopover as AKComboboxPopover,
  ComboboxProvider,
  useComboboxContext,
  useComboboxStore,
  ComboboxLabel
} from "@ariakit/react";
import { jsx as jsx15 } from "react/jsx-runtime";
var Combobox = fixedForwardRef((_a, ref) => {
  var _b = _a, { className } = _b, rest = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx15(AKCombobox, __spreadProps(__spreadValues({ className: cn("r8-select", className) }, rest), { ref }));
});
var ComboboxPopover = fixedForwardRef((_a, ref) => {
  var _b = _a, { children, className } = _b, rest = __objRest(_b, ["children", "className"]);
  return /* @__PURE__ */ jsx15(
    AKComboboxPopover,
    __spreadProps(__spreadValues({
      className: cn("r8-popover", className)
    }, rest), {
      ref,
      getAnchorRect: (el) => {
        var _a2, _b2;
        const inFormGroup = (_a2 = el == null ? void 0 : el.parentElement) == null ? void 0 : _a2.classList.contains(
          "r8-form-group__input"
        );
        if (inFormGroup) {
          const parentFormGroup = el == null ? void 0 : el.closest(".r8-form-group__control");
          return (_b2 = parentFormGroup == null ? void 0 : parentFormGroup.getBoundingClientRect()) != null ? _b2 : el == null ? void 0 : el.getBoundingClientRect();
        }
        return el == null ? void 0 : el.getBoundingClientRect();
      },
      children
    })
  );
});
var ComboboxItem = fixedForwardRef((_a, ref) => {
  var _b = _a, { className, intent } = _b, rest = __objRest(_b, ["className", "intent"]);
  const itemClass = cn(selectItem({ intent, className }));
  return /* @__PURE__ */ jsx15(AKComboboxItem, __spreadProps(__spreadValues({ className: itemClass }, rest), { ref }));
});
var ComboboxGroup = fixedForwardRef((_a, ref) => {
  var _b = _a, { children, className } = _b, rest = __objRest(_b, ["children", "className"]);
  return /* @__PURE__ */ jsx15(
    AKComboboxGroup,
    __spreadProps(__spreadValues({
      className: cn("r8-select__group", className)
    }, rest), {
      ref,
      children
    })
  );
});
var ComboboxGroupLabel = fixedForwardRef(({ children, className }, ref) => {
  return /* @__PURE__ */ jsx15(
    AKComboboxGroupLabel,
    {
      className: cn("r8-select__group-label", className),
      ref,
      children
    }
  );
});
var ComboboxList = fixedForwardRef((_a, ref) => {
  var _b = _a, { children, className } = _b, rest = __objRest(_b, ["children", "className"]);
  return /* @__PURE__ */ jsx15(
    AKComboboxList,
    __spreadProps(__spreadValues({
      className: cn("r8-select__list", className)
    }, rest), {
      ref,
      children
    })
  );
});

// src/components/radio-group/index.tsx
import {
  useRadioStore,
  RadioGroup as AKRadioGroup,
  Radio as AKRadio,
  RadioProvider,
  useRadioContext
} from "@ariakit/react";
import { jsx as jsx16 } from "react/jsx-runtime";
var RadioGroup = fixedForwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx16(
    AKRadioGroup,
    __spreadProps(__spreadValues({
      className: cn("r8-radio-group", className)
    }, props), {
      ref
    })
  );
});
var Radio = fixedForwardRef(
  (_a, ref) => {
    var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
    return /* @__PURE__ */ jsx16(
      AKRadio,
      __spreadValues({
        className: cn("r8-radio-group__item", className),
        ref
      }, props)
    );
  }
);

// src/components/tooltip/index.tsx
import {
  Tooltip as AKTooltip,
  TooltipAnchor as AKTooltipAnchor,
  TooltipArrow as AKTooltipArrow,
  TooltipProvider,
  useTooltipStore
} from "@ariakit/react";
import { jsx as jsx17 } from "react/jsx-runtime";
var TooltipAnchor = fixedForwardRef((props, ref) => {
  return /* @__PURE__ */ jsx17(AKTooltipAnchor, __spreadProps(__spreadValues({}, props), { ref }));
});
var TooltipArrow = fixedForwardRef((_a, ref) => {
  var _b = _a, { className } = _b, rest = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx17(
    AKTooltipArrow,
    __spreadProps(__spreadValues({
      className: cn("r8-tooltip__arrow", className)
    }, rest), {
      ref
    })
  );
});
var Tooltip = fixedForwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx17(AKTooltip, __spreadValues({ ref, className: cn("r8-tooltip", className) }, props));
});

// src/components/disclosure/index.tsx
import {
  DisclosureProvider,
  Disclosure as AKDisclosure,
  DisclosureContent as AKDisclosureContent,
  useDisclosureContext,
  useDisclosureStore
} from "@ariakit/react";
import { jsx as jsx18 } from "react/jsx-runtime";
var Disclosure = fixedForwardRef((_a, ref) => {
  var _b = _a, { children } = _b, rest = __objRest(_b, ["children"]);
  return /* @__PURE__ */ jsx18(AKDisclosure, __spreadProps(__spreadValues({ className: "r8-disclosure" }, rest), { ref, children }));
});
var DisclosureContent = fixedForwardRef((_a, ref) => {
  var _b = _a, { children } = _b, rest = __objRest(_b, ["children"]);
  return /* @__PURE__ */ jsx18(AKDisclosureContent, __spreadProps(__spreadValues({ className: "r8-disclosure--content", ref }, rest), { children }));
});

// src/components/form/index.tsx
import { CaretDown } from "@phosphor-icons/react";
import { cva as cva4 } from "class-variance-authority";
import { createContext, forwardRef as forwardRef5, useContext } from "react";
import { jsx as jsx19, jsxs as jsxs6 } from "react/jsx-runtime";
var variants = cva4("r8-form-group", {
  variants: {
    size: {
      sm: "r8-form-group--sm",
      md: "r8-form-group--md",
      lg: "r8-form-group--lg"
    },
    severity: {
      error: "r8-form-group--error",
      success: "r8-form-group--success"
    }
  }
});
var FormGroupContext = createContext(null);
var useFormGroupContext = () => {
  const context = useContext(FormGroupContext);
  if (!context) {
    throw new Error("FormGroupControl must be used within a FormGroup");
  }
  return context;
};
function FormGroup({
  children,
  size = "md",
  /**
   * ID is required to associate the label with the input element, as well
   * as the help text.
   */
  id,
  severity
}) {
  const className = variants({ size, severity });
  return /* @__PURE__ */ jsx19(FormGroupContext.Provider, { value: { id }, children: /* @__PURE__ */ jsx19("div", { className, children }) });
}
function FormGroupLabel(props) {
  const { id } = useFormGroupContext();
  return /* @__PURE__ */ jsx19("label", __spreadProps(__spreadValues({ htmlFor: id }, props), { className: "r8-form-group__label", children: props.children }));
}
function FormGroupControl({
  input,
  startAdornment,
  endAdornment,
  endAdornmentOptions
}) {
  return /* @__PURE__ */ jsxs6("div", { className: "r8-form-group__control", children: [
    startAdornment && /* @__PURE__ */ jsx19("div", { className: "r8-form-group__adornment r8-form-group__adornment--start", children: startAdornment }),
    /* @__PURE__ */ jsx19("div", { className: "r8-form-group__input", children: input }),
    endAdornment && /* @__PURE__ */ jsx19(
      "div",
      {
        className: `r8-form-group__adornment r8-form-group__adornment--end ${(endAdornmentOptions == null ? void 0 : endAdornmentOptions.absolute) ? "r8-form-group__adornment--absolute" : ""} ${(endAdornmentOptions == null ? void 0 : endAdornmentOptions.inert) ? "r8-form-group__adornment--inert" : ""}`,
        children: endAdornment
      }
    )
  ] });
}
function FormGroupHelpText({ children }) {
  const { id } = useFormGroupContext();
  return /* @__PURE__ */ jsx19("div", { id: `help-text-${id}`, className: "r8-form-group__help-text", children });
}
FormGroup.Label = FormGroupLabel;
FormGroup.Control = FormGroupControl;
FormGroup.HelpText = FormGroupHelpText;
var TextField = forwardRef5(
  (_a, ref) => {
    var _b = _a, {
      size,
      severity,
      label,
      helpText,
      errorText,
      startAdornment,
      endAdornment,
      id
    } = _b, inputProps = __objRest(_b, [
      "size",
      "severity",
      "label",
      "helpText",
      "errorText",
      "startAdornment",
      "endAdornment",
      "id"
    ]);
    const helpTextId = `help-text-${id}`;
    const textToShow = errorText || helpText;
    return /* @__PURE__ */ jsxs6(FormGroup, { id, size, severity: errorText ? "error" : severity, children: [
      label ? /* @__PURE__ */ jsx19(FormGroup.Label, { htmlFor: id, children: label }) : null,
      /* @__PURE__ */ jsx19(
        FormGroup.Control,
        {
          startAdornment,
          endAdornment,
          input: /* @__PURE__ */ jsx19(
            "input",
            __spreadValues({
              id,
              "aria-describedby": helpTextId,
              ref
            }, inputProps)
          )
        }
      ),
      textToShow ? /* @__PURE__ */ jsx19(FormGroup.HelpText, { children: textToShow }) : null
    ] });
  }
);
var NativeSelect = forwardRef5(
  (_a, ref) => {
    var _b = _a, {
      size,
      severity,
      label,
      helpText,
      errorText,
      startAdornment,
      id
    } = _b, inputProps = __objRest(_b, [
      "size",
      "severity",
      "label",
      "helpText",
      "errorText",
      "startAdornment",
      "id"
    ]);
    const helpTextId = `help-text-${id}`;
    const textToShow = errorText || helpText;
    return /* @__PURE__ */ jsxs6(FormGroup, { id, size, severity: errorText ? "error" : severity, children: [
      label ? /* @__PURE__ */ jsx19(FormGroup.Label, { htmlFor: id, children: label }) : null,
      /* @__PURE__ */ jsx19(
        FormGroup.Control,
        {
          startAdornment,
          endAdornment: /* @__PURE__ */ jsx19("div", { className: "r8-inert", children: /* @__PURE__ */ jsx19(CaretDown, { size: 12, weight: "bold" }) }),
          endAdornmentOptions: {
            absolute: true,
            inert: true
          },
          input: /* @__PURE__ */ jsx19(
            "select",
            __spreadProps(__spreadValues({
              id,
              "aria-describedby": helpTextId
            }, inputProps), {
              ref
            })
          )
        }
      ),
      textToShow ? /* @__PURE__ */ jsx19(FormGroup.HelpText, { children: textToShow }) : null
    ] });
  }
);
var Textarea = forwardRef5(
  (_a, ref) => {
    var _b = _a, { size, severity, label, helpText, errorText, id } = _b, inputProps = __objRest(_b, ["size", "severity", "label", "helpText", "errorText", "id"]);
    {
      const helpTextId = `help-text-${id}`;
      const textToShow = errorText || helpText;
      return /* @__PURE__ */ jsxs6(
        FormGroup,
        {
          id,
          size,
          severity: errorText ? "error" : severity,
          children: [
            label ? /* @__PURE__ */ jsx19(FormGroup.Label, { htmlFor: id, children: label }) : null,
            /* @__PURE__ */ jsx19(
              FormGroup.Control,
              {
                input: /* @__PURE__ */ jsx19(
                  "textarea",
                  __spreadProps(__spreadValues({
                    id,
                    "aria-describedby": helpTextId
                  }, inputProps), {
                    ref
                  })
                ),
                startAdornment: null,
                endAdornment: null
              }
            ),
            textToShow ? /* @__PURE__ */ jsx19(FormGroup.HelpText, { children: textToShow }) : null
          ]
        }
      );
    }
  }
);

// src/components/badge/index.tsx
import { forwardRef as forwardRef6 } from "react";
import { jsx as jsx20, jsxs as jsxs7 } from "react/jsx-runtime";
var Badge = forwardRef6(
  ({ variant, startIcon, children, size = "md", rounded }, ref) => {
    const className = cn(
      badge({ variant, size }),
      rounded ? "r8-badge--rounded" : null
    );
    return /* @__PURE__ */ jsxs7("div", { ref, className, children: [
      startIcon ? /* @__PURE__ */ jsx20("span", { className: "r8-badge__icon", children: startIcon }) : null,
      /* @__PURE__ */ jsx20("span", { children })
    ] });
  }
);
Badge.displayName = "Badge";

// src/components/box/index.tsx
import { forwardRef as forwardRef7 } from "react";
import { jsx as jsx21 } from "react/jsx-runtime";
var Box = forwardRef7(
  (_a, ref) => {
    var _b = _a, { variant, children, className } = _b, rest = __objRest(_b, ["variant", "children", "className"]);
    const boxClass = cn(box({ variant }), className);
    return /* @__PURE__ */ jsx21("div", __spreadProps(__spreadValues({ ref, className: boxClass }, rest), { children }));
  }
);
Box.displayName = "Box";

// src/components/goo/index.tsx
import { useRafInterval, useSize } from "ahooks";
import { motion, useInView, useReducedMotion } from "framer-motion";
import { useEffect as useEffect2, useRef as useRef2, useState as useState2 } from "react";

// src/components/goo/goo-fallback.jpg
var goo_fallback_default = "data:image/jpeg;base64,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";

// src/components/goo/index.tsx
import { jsx as jsx22 } from "react/jsx-runtime";
function Goo({
  speed,
  resolution,
  depth,
  seed = 0,
  still = false,
  variant = "color"
}) {
  const wrapRef = useRef2(null);
  const inView = useInView(wrapRef);
  const size = useSize(wrapRef);
  return /* @__PURE__ */ jsx22(
    motion.div,
    {
      ref: wrapRef,
      id: "goo-wrap",
      "aria-hidden": "true",
      initial: { opacity: 0 },
      animate: { opacity: 1 },
      transition: { duration: still ? 0 : 0.5 },
      className: "goo-wrapper",
      children: size ? /* @__PURE__ */ jsx22(
        GooCanvas,
        {
          speed,
          seed,
          resolution,
          depth,
          size,
          inView,
          still,
          variant
        }
      ) : null
    }
  );
}
function GooCanvas({
  inView,
  size,
  speed,
  resolution,
  depth,
  seed,
  still,
  variant
}) {
  const mousePosRef = useRef2({ x: 0, y: 0 });
  const startRef = useRef2(performance.now());
  const canvasRef = useRef2(null);
  const glRef = useRef2(null);
  const shaderProgramRef = useRef2(null);
  const reducedMotion = useReducedMotion();
  if (typeof window === "undefined") {
    console.error(
      "The goo component cannot be server-side rendered as it requires WebGL and browser APIs"
    );
    return null;
  }
  const [invert, setInvert] = useState2(
    () => {
      var _a;
      return ((_a = window.matchMedia) == null ? void 0 : _a.call(window, "(prefers-color-scheme: dark)").matches) ? -1 : 1;
    }
  );
  useEffect2(() => {
    if (variant !== "contour") return;
    const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");
    const handleChange = (e) => {
      setInvert(e.matches ? -1 : 1);
    };
    mediaQuery.addEventListener("change", handleChange);
    return () => mediaQuery.removeEventListener("change", handleChange);
  }, [variant]);
  const [tint, setTint] = useState2(invert ? [1, 1, 1] : [0, 0, 0]);
  useEffect2(() => {
    if (variant !== "contour") return;
    if (canvasRef.current && invert) {
      const colorString = getComputedStyle(canvasRef.current).getPropertyValue(
        "color"
      );
      const rgb = colorString.match(/\d+/g);
      if (rgb) {
        setTint(rgb.map((c) => Number.parseInt(c) / 255));
      }
    }
  }, [invert, variant]);
  const vertexShaderSource = `
	attribute vec2 position;
	void main() {
			gl_Position = vec4(position, 0.0, 1.0);
	}
`;
  const maxDepth = Math.min(Math.max(depth, 1), 20);
  const fragmentShaderSource = variant === "contour" ? `
#extension GL_OES_standard_derivatives : enable

precision mediump float;
uniform vec2 iResolution;
uniform float iTime;
uniform vec2 iMouse;
uniform float iInvert;
uniform vec3 iTint;

vec3 colorBlack = vec3(0.0, 0.0, 0.0);
vec3 colorWhite = vec3(1.0, 1.0, 1.0);

vec2 effect(vec2 p, float i, float time) {
    float speed = ${speed.toFixed(2)};
    return vec2(sin(p.x * i + (time * speed)) * cos(p.y * i + (time * speed)), sin(length(p.x)) * cos(length(p.y)));
}

void main() {
    vec2 p = (gl_FragCoord.xy - iResolution.xy) / max(iResolution.x, iResolution.y);
    p.x += ${seed.toFixed(1)};
    p.y += ${seed.toFixed(1)};
    
    p *= ${resolution.toFixed(1)};
    for (int i = 1; i < ${maxDepth}; i++) {
        float fi = float(i);
        p += effect(p, fi, iTime);
    }
    vec3 noise = mix(mix(colorBlack, colorWhite, 1.0-sin(p.x)), colorBlack, cos(p.y+p.x));

    float spacing = 1.0 / (iResolution.x * 0.0025);
    float lines = mod(noise.r, spacing) / spacing;
    lines = min(lines * 2.0, 1.0) - max(lines * 2.0 - 1.0, 0.0);
    lines /= fwidth(noise.r / spacing);
    
    float weight = smoothstep(0.0, 1.0, gl_FragCoord.y / iResolution.y);
    weight = mix(2.0, 5.0, weight);
    
    lines -= weight;
    float alpha = clamp(1.0 - lines, 0.0, 1.0);
    
    gl_FragColor = vec4(iTint, alpha);
}
` : `
precision mediump float;
uniform vec2 iResolution;
uniform float iTime;
uniform vec2 iMouse;

vec3 color1 = vec3(235.0/255.0, 231.0/255.0, 92.0/255.0);
vec3 color2 = vec3(223.0/255.0, 72.0/255.0, 67.0/255.0);
vec3 color3 = vec3(235.0/255.0, 64.0/255.0, 240.0/255.0);

vec2 effect(vec2 p, float i, float time) {
    float speed = ${speed.toFixed(2)};
    return vec2(sin(p.x * i + (time * speed)) * cos(p.y * i + (time * speed)), sin(length(p.x)) * cos(length(p.y)));
}

void main() {
    vec2 p = (2.0 * gl_FragCoord.xy - iResolution.xy) / max(iResolution.x, iResolution.y);
    p.x += ${seed.toFixed(1)};
    p.y += ${seed.toFixed(1)};
    
    p *= ${resolution.toFixed(1)};
    for (int i = 1; i < ${maxDepth}; i++) {
        float fi = float(i);
        p += effect(p, fi, iTime);
    }
    vec3 col = mix(mix(color1, color2, 1.0-sin(p.x)), color3, cos(p.y+p.x));
    gl_FragColor = vec4(col, 1.0);
}
`;
  useEffect2(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const gl = canvas.getContext("webgl", {
      preserveDrawingBuffer: still,
      antialias: true
    }) || canvas.getContext("experimental-webgl");
    if (!gl) {
      console.error(
        "Unable to initialize WebGL. Your browser may not support it."
      );
      return;
    }
    if (variant === "contour") {
      const ext = gl.getExtension("OES_standard_derivatives");
      if (!ext) {
        console.warn("OES_standard_derivatives not supported");
      }
    }
    const vertexShader = gl.createShader(gl.VERTEX_SHADER);
    if (!vertexShader) return;
    gl.shaderSource(vertexShader, vertexShaderSource);
    gl.compileShader(vertexShader);
    if (!gl.getShaderParameter(vertexShader, gl.COMPILE_STATUS)) {
      console.error(
        "Vertex shader compilation error:",
        gl.getShaderInfoLog(vertexShader)
      );
      gl.deleteShader(vertexShader);
      return;
    }
    const fragmentShader = gl.createShader(gl.FRAGMENT_SHADER);
    if (!fragmentShader) return;
    gl.shaderSource(fragmentShader, fragmentShaderSource);
    gl.compileShader(fragmentShader);
    if (!gl.getShaderParameter(fragmentShader, gl.COMPILE_STATUS)) {
      console.error(
        "Fragment shader compilation error:",
        gl.getShaderInfoLog(fragmentShader)
      );
      gl.deleteShader(vertexShader);
      gl.deleteShader(fragmentShader);
      return;
    }
    const shaderProgram = gl.createProgram();
    if (!shaderProgram) return;
    gl.attachShader(shaderProgram, vertexShader);
    gl.attachShader(shaderProgram, fragmentShader);
    gl.linkProgram(shaderProgram);
    if (!gl.getProgramParameter(shaderProgram, gl.LINK_STATUS)) {
      console.error(
        "Shader program linking error:",
        gl.getProgramInfoLog(shaderProgram)
      );
      gl.deleteProgram(shaderProgram);
      gl.deleteShader(vertexShader);
      gl.deleteShader(fragmentShader);
      return;
    }
    gl.useProgram(shaderProgram);
    const positionBuffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, positionBuffer);
    const positions = [
      -1,
      -1,
      1,
      -1,
      -1,
      1,
      -1,
      1,
      1,
      -1,
      1,
      1
    ];
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(positions), gl.STATIC_DRAW);
    const positionLocation = gl.getAttribLocation(shaderProgram, "position");
    gl.enableVertexAttribArray(positionLocation);
    gl.vertexAttribPointer(positionLocation, 2, gl.FLOAT, false, 0, 0);
    glRef.current = gl;
    shaderProgramRef.current = shaderProgram;
  }, [variant, speed, resolution, seed, maxDepth]);
  useEffect2(() => {
    const gl = glRef.current;
    const shaderProgram = shaderProgramRef.current;
    const { width, height } = size;
    if (!gl || !shaderProgram) return;
    gl.viewport(0, 0, width * devicePixelRatio, height * devicePixelRatio);
    const iResolutionLocation = gl.getUniformLocation(
      shaderProgram,
      "iResolution"
    );
    gl.uniform2f(iResolutionLocation, gl.canvas.width, gl.canvas.height);
  }, [size]);
  const frameHandler = () => {
    const start = startRef.current;
    const time = performance.now() - start;
    const mousePos = mousePosRef.current;
    if ((reducedMotion || still) && time >= 50) {
      return;
    }
    const gl = glRef.current;
    const shaderProgram = shaderProgramRef.current;
    if (!gl || !shaderProgram) return;
    const iTimeLocation = gl.getUniformLocation(shaderProgram, "iTime");
    const iMouseLocation = gl.getUniformLocation(shaderProgram, "iMouse");
    gl.uniform2f(iMouseLocation, mousePos.x, mousePos.y);
    gl.uniform1f(iTimeLocation, time * 1e-3);
    if (variant === "contour") {
      const iTintLocation = gl.getUniformLocation(shaderProgram, "iTint");
      const iInvertLocation = gl.getUniformLocation(shaderProgram, "iInvert");
      gl.uniform3f(iTintLocation, tint[0], tint[1], tint[2]);
      gl.uniform1f(iInvertLocation, invert);
    }
    gl.clear(gl.COLOR_BUFFER_BIT);
    gl.drawArrays(gl.TRIANGLES, 0, 6);
  };
  const devicePixelRatio = window.devicePixelRatio || 1;
  useRafInterval(frameHandler, inView ? 1e3 / 60 : void 0);
  return /* @__PURE__ */ jsx22(
    "canvas",
    {
      width: size.width * devicePixelRatio,
      height: size.height * devicePixelRatio,
      ref: canvasRef,
      className: "goo-canvas",
      style: variant === "color" ? { backgroundImage: `url(${goo_fallback_default})` } : void 0
    }
  );
}

// src/components/site-footer/index.tsx
import React3 from "react";

// src/components/site-navigation/index.tsx
import * as Ariakit from "@ariakit/react";
import { ArrowsOut } from "@phosphor-icons/react/dist/ssr/ArrowsOut";
import { CaretDown as CaretDown2 } from "@phosphor-icons/react/dist/ssr/CaretDown";
import { CaretRight } from "@phosphor-icons/react/dist/ssr/CaretRight";
import { GraduationCap as GraduationCap2 } from "@phosphor-icons/react/dist/ssr/GraduationCap";
import { Image } from "@phosphor-icons/react/dist/ssr/Image";
import { ImageSquare } from "@phosphor-icons/react/dist/ssr/ImageSquare";
import { List as List2 } from "@phosphor-icons/react/dist/ssr/List";
import { Microphone } from "@phosphor-icons/react/dist/ssr/Microphone";
import { Plus as Plus2 } from "@phosphor-icons/react/dist/ssr/Plus";
import { Rocket as Rocket2 } from "@phosphor-icons/react/dist/ssr/Rocket";
import { TextT } from "@phosphor-icons/react/dist/ssr/TextT";
import { Video } from "@phosphor-icons/react/dist/ssr/Video";
import React2, {
  useMemo as useMemo2,
  useState as useState3,
  useRef as useRef3,
  forwardRef as forwardRef8,
  useEffect as useEffect3
} from "react";
import {
  Cube,
  GridNine,
  TextAa
} from "@phosphor-icons/react";
import { Fragment, jsx as jsx23, jsxs as jsxs8 } from "react/jsx-runtime";
var exploreMenu = [
  {
    title: "Explore models",
    items: [
      {
        icon: /* @__PURE__ */ jsx23(Image, { size: 18 }),
        label: "Image models",
        href: "/collections/text-to-image"
      },
      {
        icon: /* @__PURE__ */ jsx23(Video, { size: 18 }),
        label: "Video models",
        href: "/collections/text-to-video"
      },
      {
        icon: /* @__PURE__ */ jsx23(TextT, { size: 18 }),
        label: "Language models",
        href: "/collections/language-models"
      },
      {
        icon: /* @__PURE__ */ jsx23(CaretRight, { size: 18 }),
        label: "Explore all models",
        href: "/explore",
        className: "v2-menu-item-small"
      }
    ]
  },
  {
    title: "View collections",
    items: [
      {
        icon: /* @__PURE__ */ jsx23(ArrowsOut, { size: 18 }),
        label: "Upscale images",
        href: "/collections/super-resolution"
      },
      {
        icon: /* @__PURE__ */ jsx23(ImageSquare, { size: 18 }),
        label: "Remove backgrounds",
        href: "/collections/remove-backgrounds"
      },
      {
        icon: /* @__PURE__ */ jsx23(Microphone, { size: 18 }),
        label: "Transcribe speech",
        href: "/collections/speech-to-text"
      },
      {
        icon: /* @__PURE__ */ jsx23(CaretRight, { size: 18 }),
        label: "View all collections",
        href: "/collections",
        className: "v2-menu-item-small"
      }
    ]
  }
];
var createMenu = [
  {
    icon: /* @__PURE__ */ jsx23(Plus2, { size: 18 }),
    label: "Create a model",
    internal: true,
    href: "/create",
    description: "Start building on Replicate"
  },
  {
    icon: /* @__PURE__ */ jsx23(Cube, { size: 18 }),
    label: "Push a model",
    internal: true,
    href: "/docs/guides/push-a-model",
    description: "Build a model locally and deploy it"
  },
  {
    icon: /* @__PURE__ */ jsx23(GraduationCap2, { size: 18 }),
    label: "Train a model",
    internal: true,
    href: "/docs/get-started/fine-tune-with-flux",
    description: "Use Flux to generate images with a specific subject or style"
  },
  {
    icon: /* @__PURE__ */ jsx23(Rocket2, { size: 18 }),
    label: "Create a deployment",
    internal: true,
    href: "/docs/topics/deployments/create-a-deployment",
    description: "Create your private model in the cloud"
  }
];
var baseLinks = [
  Links.explore,
  Links.pricing,
  Links.enterprise,
  Links.docs,
  Links.blog
];
function makeHeaderLinks(authState) {
  let links = [...baseLinks];
  if (authState !== "anonymous") {
    links = [Links.dashboard, ...links];
  } else {
    links = [...links, Links.signin, Links.signup];
  }
  return links;
}
function SiteNavigationInner({
  authState,
  currentPath,
  kind,
  username,
  anchorProps = () => ({}),
  renderLink
}) {
  const dashboardMenuStore = Ariakit.useMenuStore();
  const exploreMenuStore = Ariakit.useMenuStore();
  const createMenuStore = Ariakit.useMenuStore();
  const defaultNavigationItems = useMemo2(() => {
    const items = [
      Links.pricing,
      Links.enterprise,
      Links.docs,
      Links.blog
    ];
    if (authState === "anonymous") {
      items.push(Links.signin);
      items.push(Links.signup);
    }
    return items;
  }, [authState]);
  const defaultDashboardItems = useMemo2(() => {
    const items = [
      DashboardLinks.dashboard,
      DashboardLinks.models,
      DashboardLinks.predictions,
      DashboardLinks.trainings,
      DashboardLinks.deployments,
      DashboardLinks.webhooks
    ];
    if (kind === "user") {
      items.push(__spreadProps(__spreadValues({}, DashboardLinks.stars), {
        href: `/${username}/stars`
      }));
    }
    items.push(DashboardLinks.support);
    return items;
  }, [kind, username]);
  return /* @__PURE__ */ jsxs8(Ariakit.Menubar, { className: "v2-menubar", children: [
    authState === "authenticated" ? /* @__PURE__ */ jsxs8(
      Ariakit.MenuProvider,
      {
        timeout: 0,
        placement: "bottom",
        store: dashboardMenuStore,
        children: [
          /* @__PURE__ */ jsxs8(
            Ariakit.MenuItem,
            {
              tabbable: true,
              className: "v2-dropdown-item group",
              render: /* @__PURE__ */ jsx23(
                Ariakit.MenuButton,
                {
                  onFocusVisible: () => {
                    exploreMenuStore.hide();
                    createMenuStore.hide();
                    dashboardMenuStore.show();
                  },
                  toggleOnClick: () => {
                    exploreMenuStore.hide();
                    createMenuStore.hide();
                    dashboardMenuStore.show();
                    return false;
                  },
                  render: createLinkRender({
                    item: Links.dashboard,
                    currentPath,
                    anchorProps,
                    renderLink
                  }),
                  showOnHover: true
                }
              ),
              children: [
                /* @__PURE__ */ jsx23("span", { children: "Dashboard" }),
                /* @__PURE__ */ jsx23(CaretDown2, { className: "v2-dropdown-item-caret", weight: "bold" })
              ]
            }
          ),
          /* @__PURE__ */ jsx23(
            Ariakit.Menu,
            {
              hideOnHoverOutside: true,
              focusable: false,
              unmountOnHide: true,
              className: "v2-dropdown-menu v2-dropdown-menu--dashboard",
              children: defaultDashboardItems.map((item) => /* @__PURE__ */ jsxs8(
                Ariakit.MenuItem,
                {
                  tabbable: true,
                  focusOnHover: false,
                  blurOnHoverEnd: true,
                  className: "v2-dropdown-menu-item",
                  render: createLinkRender({
                    item,
                    currentPath,
                    anchorProps,
                    renderLink
                  }),
                  children: [
                    /* @__PURE__ */ jsx23("span", { className: "v2-dropdown-menu-item--icon", children: item.icon }),
                    /* @__PURE__ */ jsxs8("div", { children: [
                      /* @__PURE__ */ jsx23("div", { className: "v2-dropdown-menu-item--label", children: item.label }),
                      /* @__PURE__ */ jsx23("div", { className: "v2-dropdown-menu-item--description", children: item.description })
                    ] })
                  ]
                },
                item.label
              ))
            }
          )
        ]
      }
    ) : null,
    /* @__PURE__ */ jsxs8(
      Ariakit.MenuProvider,
      {
        timeout: 0,
        placement: "bottom",
        store: exploreMenuStore,
        children: [
          /* @__PURE__ */ jsxs8(
            Ariakit.MenuItem,
            {
              tabbable: true,
              className: "v2-dropdown-item group",
              render: /* @__PURE__ */ jsx23(
                Ariakit.MenuButton,
                {
                  showOnHover: true,
                  onFocusVisible: () => {
                    dashboardMenuStore.hide();
                    createMenuStore.hide();
                    exploreMenuStore.show();
                  },
                  toggleOnClick: () => {
                    dashboardMenuStore.hide();
                    createMenuStore.hide();
                    exploreMenuStore.show();
                    return false;
                  },
                  render: createLinkRender({
                    item: Links.explore,
                    currentPath,
                    anchorProps,
                    renderLink
                  })
                }
              ),
              children: [
                /* @__PURE__ */ jsx23("span", { children: "Explore" }),
                /* @__PURE__ */ jsx23(CaretDown2, { className: "v2-dropdown-item-caret", weight: "bold" })
              ]
            }
          ),
          /* @__PURE__ */ jsxs8(
            Ariakit.Menu,
            {
              hideOnHoverOutside: true,
              focusable: false,
              unmountOnHide: true,
              className: "v2-dropdown-menu v2-dropdown-menu--explore",
              children: [
                exploreMenu.map((section) => /* @__PURE__ */ jsxs8(
                  "div",
                  {
                    className: "v2-dropdown-menu--explore-section",
                    children: [
                      /* @__PURE__ */ jsx23("h3", { className: "v2-dropdown-menu--explore-section-title", children: section.title }),
                      /* @__PURE__ */ jsx23("ul", { className: "v2-dropdown-menu--explore-section-list", children: section.items.map((item) => {
                        var _a;
                        return /* @__PURE__ */ jsx23("li", { children: /* @__PURE__ */ jsxs8(
                          Ariakit.MenuItem,
                          {
                            tabbable: true,
                            focusOnHover: false,
                            blurOnHoverEnd: true,
                            className: "v2-dropdown-menu-item v2-dropdown-menu-item--explore",
                            render: createLinkRender({
                              item,
                              currentPath,
                              anchorProps,
                              renderLink
                            }),
                            children: [
                              /* @__PURE__ */ jsx23("span", { className: "v2-dropdown-menu-item--explore-icon", children: item.icon }),
                              /* @__PURE__ */ jsx23(
                                "span",
                                {
                                  className: `v2-dropdown-menu-item--explore-label ${"className" in item ? (_a = item.className) != null ? _a : "" : ""}`,
                                  children: item.label
                                }
                              )
                            ]
                          }
                        ) }, item.label);
                      }) })
                    ]
                  },
                  section.title
                )),
                /* @__PURE__ */ jsx23(
                  Ariakit.MenuItem,
                  {
                    tabbable: true,
                    focusOnHover: false,
                    blurOnHoverEnd: true,
                    className: "v2-dropdown-menu-item v2-dropdown-menu-item--playground",
                    render: createLinkRender({
                      item: Links.playground,
                      currentPath,
                      anchorProps,
                      renderLink
                    }),
                    children: /* @__PURE__ */ jsxs8("div", { className: "v2-dropdown-menu-item-playground-wrapper", children: [
                      /* @__PURE__ */ jsx23("div", { className: "v2-dropdown-menu-item-playground-icon", children: /* @__PURE__ */ jsx23(GridNine, {}) }),
                      /* @__PURE__ */ jsxs8("div", { className: "v2-dropdown-menu-item--playground-label", children: [
                        /* @__PURE__ */ jsxs8("span", { className: "v2-playground-label-part-1", children: [
                          "Compare models in the",
                          " "
                        ] }),
                        /* @__PURE__ */ jsx23("span", { className: "v2-playground-label-part-2", children: "Playground" }),
                        /* @__PURE__ */ jsx23("span", { className: "v2-beta-badge", children: "Beta" })
                      ] })
                    ] })
                  }
                )
              ]
            }
          )
        ]
      }
    ),
    authState === "authenticated" ? /* @__PURE__ */ jsxs8(
      Ariakit.MenuProvider,
      {
        timeout: 0,
        placement: "bottom",
        store: createMenuStore,
        children: [
          /* @__PURE__ */ jsxs8(
            Ariakit.MenuItem,
            {
              tabbable: true,
              className: "v2-dropdown-item group",
              render: /* @__PURE__ */ jsx23(
                Ariakit.MenuButton,
                {
                  onFocusVisible: () => {
                    exploreMenuStore.hide();
                    dashboardMenuStore.hide();
                    createMenuStore.show();
                  },
                  toggleOnClick: () => {
                    exploreMenuStore.hide();
                    dashboardMenuStore.hide();
                    createMenuStore.show();
                    return false;
                  },
                  render: createLinkRender({
                    item: Links.create,
                    currentPath,
                    anchorProps,
                    renderLink
                  }),
                  showOnHover: true
                }
              ),
              children: [
                /* @__PURE__ */ jsx23("span", { children: "Create" }),
                /* @__PURE__ */ jsx23(CaretDown2, { className: "v2-dropdown-item-caret", weight: "bold" })
              ]
            }
          ),
          /* @__PURE__ */ jsx23(
            Ariakit.Menu,
            {
              hideOnHoverOutside: true,
              focusable: false,
              unmountOnHide: true,
              className: "v2-dropdown-menu v2-dropdown-menu--create",
              children: createMenu.map((item) => /* @__PURE__ */ jsxs8(
                Ariakit.MenuItem,
                {
                  tabbable: true,
                  focusOnHover: false,
                  blurOnHoverEnd: true,
                  className: "v2-dropdown-menu-item",
                  render: createLinkRender({
                    item,
                    currentPath,
                    anchorProps,
                    renderLink
                  }),
                  children: [
                    /* @__PURE__ */ jsx23("span", { className: "v2-dropdown-menu-item--icon", children: item.icon }),
                    /* @__PURE__ */ jsxs8("div", { children: [
                      /* @__PURE__ */ jsx23("div", { className: "v2-dropdown-menu-item--label", children: item.label }),
                      /* @__PURE__ */ jsx23("div", { className: "v2-dropdown-menu-item--description", children: item.description })
                    ] })
                  ]
                },
                item.label
              ))
            }
          )
        ]
      }
    ) : null,
    defaultNavigationItems.map((item) => {
      return /* @__PURE__ */ jsx23(Ariakit.MenuProvider, { timeout: 0, children: /* @__PURE__ */ jsxs8(
        Ariakit.MenuItem,
        {
          tabbable: true,
          focusOnHover: false,
          render: createLinkRender({
            item,
            currentPath,
            anchorProps,
            renderLink,
            additionalProps: {
              className: ` ${item.primary ? "v2-menu-item-primary" : "v2-menu-item"} group`
            }
          }),
          children: [
            item.icon,
            /* @__PURE__ */ jsx23("span", { className: "v2-menu-item-label", children: item.label })
          ]
        }
      ) }, item.label);
    })
  ] });
}
function SiteNavigation(props) {
  const {
    authState,
    variant,
    avatar,
    meta,
    logo = "glyph",
    onDisclosureOpenChange = () => {
    },
    anchorProps = () => {
    },
    search,
    renderLink
  } = props;
  const links = makeHeaderLinks(authState);
  const headerRef = useRef3(null);
  const renderMobileLinkElement = (item, children, additionalProps = {}) => {
    const isActive = isItemActive(item, props.currentPath);
    const _a = additionalProps, { key } = _a, additionalPropsWithoutKey = __objRest(_a, ["key"]);
    const allProps = __spreadValues(__spreadValues({
      href: item.href,
      "data-active": isActive
    }, anchorProps(item)), additionalPropsWithoutKey);
    if (renderLink) {
      const domSafeProps = Object.fromEntries(
        Object.entries(allProps).filter(
          ([key2]) => !["isActive", "label", "children"].includes(key2)
        )
      );
      return /* @__PURE__ */ jsx23(React2.Fragment, { children: renderLink(__spreadValues({
        // Metadata (not for spreading)
        href: item.href,
        isActive,
        label: item.label,
        children
      }, domSafeProps)) }, key);
    }
    return /* @__PURE__ */ jsx23("a", __spreadProps(__spreadValues({}, allProps), { children }), key);
  };
  useEffect3(() => {
    if (variant !== "floating") return;
    const handleScroll = () => {
      if (!headerRef.current) return;
      const scrolled = window.scrollY > 0;
      headerRef.current.setAttribute("data-scrolled", scrolled.toString());
    };
    handleScroll();
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [variant]);
  return /* @__PURE__ */ jsxs8(
    Ariakit.DisclosureProvider,
    {
      setOpen: (open) => {
        if (open) {
          document.documentElement.scrollTo({
            top: 0,
            behavior: "instant"
          });
        }
        onDisclosureOpenChange(open);
      },
      children: [
        /* @__PURE__ */ jsx23("header", { ref: headerRef, "data-variant": variant, className: "v2-header", children: /* @__PURE__ */ jsxs8("div", { className: "v2-header-inner", children: [
          /* @__PURE__ */ jsx23("div", { className: "v2-header-transparent-backdrop" }),
          /* @__PURE__ */ jsxs8("div", { "data-header-container": true, className: "v2-header-container", children: [
            /* @__PURE__ */ jsxs8("div", { className: "v2-header-wrapper", children: [
              logo === "wordmark" ? /* @__PURE__ */ jsx23(MarketingLogo, {}) : /* @__PURE__ */ jsx23(Logo, {}),
              avatar ? /* @__PURE__ */ jsx23("div", { className: "v2-header-avatar", children: avatar }) : null,
              search ? /* @__PURE__ */ jsx23("div", { className: "v2-header-search", children: search }) : null,
              meta ? /* @__PURE__ */ jsx23("div", { className: "v2-header-meta", children: meta }) : null
            ] }),
            /* @__PURE__ */ jsx23("div", { className: "v2-header-desktop-nav", children: /* @__PURE__ */ jsx23(SiteNavigationInner, __spreadValues({}, props)) }),
            /* @__PURE__ */ jsx23("div", { className: "v2-header-mobile-nav", children: /* @__PURE__ */ jsx23(
              Ariakit.Disclosure,
              {
                render: /* @__PURE__ */ jsx23(
                  Button,
                  {
                    variant: "outlined",
                    size: "sm",
                    startIcon: /* @__PURE__ */ jsx23(List2, { weight: "bold" })
                  }
                ),
                children: "Menu"
              }
            ) })
          ] })
        ] }) }),
        /* @__PURE__ */ jsx23(Ariakit.DisclosureContent, { className: "v2-header-mobile-nav-disclosure", children: /* @__PURE__ */ jsx23("div", { className: "v2-header-mobile-nav-disclosure-inner", children: /* @__PURE__ */ jsx23("div", { className: "v2-header-mobile-nav-disclosure-container", children: /* @__PURE__ */ jsxs8("nav", { className: "v2-header-mobile-nav-disclosure-nav", children: [
          links.map((link) => {
            return renderMobileLinkElement(
              link,
              /* @__PURE__ */ jsxs8(Fragment, { children: [
                link.icon,
                link.label
              ] }),
              {
                key: link.label,
                className: `v2-header-mobile-link ${link.primary ? "v2-header-mobile-link--primary" : ""}`
              }
            );
          }),
          authState !== "anonymous" && renderMobileLinkElement(
            Links.create,
            /* @__PURE__ */ jsxs8(Fragment, { children: [
              Links.create.icon,
              Links.create.label
            ] }),
            {
              key: Links.create.label,
              className: `v2-header-mobile-link ${"primary" in Links.create && Links.create.primary ? "v2-header-mobile-link--primary" : ""}`
            }
          ),
          /* @__PURE__ */ jsx23("hr", { className: "v2-header-mobile-divider" }),
          renderMobileLinkElement(
            Links.playground,
            /* @__PURE__ */ jsxs8(Fragment, { children: [
              /* @__PURE__ */ jsxs8("span", { className: "v2-playground-label-part-1", children: [
                "Compare models in the",
                " "
              ] }),
              /* @__PURE__ */ jsx23("span", { className: "v2-playground-label-part-2", children: "Playground" }),
              /* @__PURE__ */ jsx23("span", { className: "v2-beta-badge", children: "Beta" })
            ] }),
            {
              key: Links.playground.href,
              className: "v2-header-mobile-link v2-header-mobile-link--playground"
            }
          )
        ] }) }) }) })
      ]
    }
  );
}
var GlyphSVG = forwardRef8((_props, ref) => {
  return /* @__PURE__ */ jsxs8(
    "svg",
    {
      ref,
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      xmlSpace: "preserve",
      viewBox: "0 0 1000 1000",
      width: "100%",
      height: "100%",
      fill: "currentColor",
      children: [
        /* @__PURE__ */ jsx23("title", { children: "Replicate glyph" }),
        /* @__PURE__ */ jsxs8("g", { children: [
          /* @__PURE__ */ jsx23("polygon", { points: "1000,427.6 1000,540.6 603.4,540.6 603.4,1000 477,1000 477,427.6" }),
          /* @__PURE__ */ jsx23("polygon", { points: "1000,213.8 1000,327 364.8,327 364.8,1000 238.4,1000 238.4,213.8" }),
          /* @__PURE__ */ jsx23("polygon", { points: "1000,0 1000,113.2 126.4,113.2 126.4,1000 0,1000 0,0" })
        ] })
      ]
    }
  );
});
var WordmarkSVG = forwardRef8((_props, ref) => {
  return /* @__PURE__ */ jsxs8(
    "svg",
    {
      ref,
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 120",
      children: [
        /* @__PURE__ */ jsx23("title", { children: "Replicate wordmark" }),
        /* @__PURE__ */ jsx23("polygon", { points: "86.96 0 86.96 10.74 12.03 10.74 12.03 95.41 0 95.41 0 0 86.96 0" }),
        /* @__PURE__ */ jsx23("polygon", { points: "86.96 20.37 86.96 31.11 34.75 31.11 34.75 95.41 22.71 95.41 22.71 20.37 86.96 20.37" }),
        /* @__PURE__ */ jsx23("polygon", { points: "86.96 40.67 86.96 51.47 57.46 51.47 57.46 95.41 45.42 95.41 45.42 40.67 86.96 40.67" }),
        /* @__PURE__ */ jsx23("path", { d: "m121.21,39.62c14.32,0,26.35,9.5,26.35,27.16,0,1.17,0,2.16-.12,3.95h-43.02c.56,8.95,7.78,14.87,16.85,14.87,7.65,0,12.78-3.52,15.61-8.33l9.2,6.54c-4.94,7.78-13.45,12.71-24.93,12.71-16.6,0-28.57-11.79-28.57-28.45.06-16.11,12.03-28.45,28.64-28.45m-16.17,22.28h30.43c-1.3-7.9-7.65-12.16-14.69-12.16s-14.13,4.07-15.74,12.16" }),
        /* @__PURE__ */ jsx23("path", { d: "m159.78,40.67h12.03v7.34c3.09-4.38,9.75-8.39,17.59-8.39,15,0,26.35,12.78,26.35,28.45s-11.36,28.45-26.35,28.45c-7.9,0-14.57-4.07-17.59-8.46v30.18h-12.03V40.67Zm27.46,9.87c-9.75,0-16.42,7.65-16.42,17.53s6.67,17.53,16.42,17.53,16.29-7.65,16.29-17.53-6.67-17.53-16.29-17.53" }),
        /* @__PURE__ */ jsx23("rect", { x: "228.04", y: "13.33", width: "12.03", height: "82.02" }),
        /* @__PURE__ */ jsx23("path", { d: "m262.3,28.76c-4.38,0-8.08-3.58-8.08-8.08s3.7-7.96,8.08-7.96,7.96,3.64,7.96,7.96c0,4.51-3.46,8.08-7.96,8.08m-5.99,11.91h12.03v54.68h-12.03v-54.68Z" }),
        /* @__PURE__ */ jsx23("path", { d: "m309.45,96.46c-16.42,0-28.88-12.28-28.88-28.45s12.47-28.45,28.88-28.45c11.29,0,20.8,6.05,25.49,15.12l-10.49,5.68c-2.65-5.55-7.96-9.63-15-9.63-9.75,0-16.6,7.53-16.6,17.28s6.91,17.28,16.6,17.28c6.97,0,12.34-4.07,15-9.63l10.49,5.68c-4.69,9.13-14.26,15.12-25.49,15.12" }),
        /* @__PURE__ */ jsx23("path", { d: "m368.39,39.62c7.9,0,14.44,4.07,17.53,8.39v-7.34h12.03v54.68h-12.03v-7.34c-3.09,4.38-9.63,8.46-17.53,8.46-15,0-26.35-12.78-26.35-28.45s11.36-28.39,26.35-28.39m2.22,10.92c-9.75,0-16.29,7.65-16.29,17.53s6.54,17.53,16.29,17.53,16.29-7.65,16.29-17.53-6.6-17.53-16.29-17.53" }),
        /* @__PURE__ */ jsx23("polygon", { points: "418.56 95.41 418.56 51.41 407.14 51.41 407.14 40.67 418.56 40.67 418.56 25.49 430.6 25.49 430.6 40.67 451.33 40.67 451.33 51.41 430.6 51.41 430.6 84.61 451.33 84.61 451.33 95.41 418.56 95.41" }),
        /* @__PURE__ */ jsx23("path", { d: "m485.65,39.62c14.32,0,26.35,9.5,26.35,27.16,0,1.17,0,2.16-.12,3.95h-43.02c.56,8.95,7.78,14.87,16.85,14.87,7.65,0,12.78-3.52,15.61-8.33l9.2,6.54c-4.94,7.78-13.45,12.71-24.93,12.71-16.6,0-28.57-11.79-28.57-28.45.12-16.11,12.03-28.45,28.64-28.45m-16.17,22.28h30.43c-1.3-7.9-7.65-12.16-14.69-12.16s-14.07,4.07-15.74,12.16" })
      ]
    }
  );
});
function downloadSvg(filename, svg) {
  const link = document.createElement("a");
  link.href = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;
  link.download = filename;
  link.target = "_blank";
  link.rel = "noopener noreferrer";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
function Logo() {
  return /* @__PURE__ */ jsx23("a", { className: "v2-header-logo", href: "/", children: /* @__PURE__ */ jsx23(GlyphSVG, {}) });
}
function MarketingLogo() {
  const [anchorRect, setAnchorRect] = useState3(null);
  const menu = Ariakit.useMenuStore({ focusLoop: true });
  const glyphRef = useRef3(null);
  const wordmarkRef = useRef3(null);
  const handleDownloadGlyph = () => {
    if (glyphRef.current) {
      const svgString = glyphRef.current.outerHTML;
      downloadSvg("replicate-glyph.svg", svgString);
    }
  };
  const handleDownloadWordmark = () => {
    if (wordmarkRef.current) {
      const svgString = wordmarkRef.current.outerHTML;
      downloadSvg("replicate-wordmark.svg", svgString);
    }
  };
  return /* @__PURE__ */ jsxs8(Fragment, { children: [
    /* @__PURE__ */ jsxs8(
      "a",
      {
        onContextMenu: (event) => {
          event.preventDefault();
          const bbox = event.currentTarget.getBoundingClientRect();
          setAnchorRect({ x: bbox.x, y: bbox.y + bbox.height });
          menu.show();
        },
        href: "/",
        className: "v2-marketing-logo",
        children: [
          /* @__PURE__ */ jsx23("div", { className: "v2-marketing-logo-glyph", children: /* @__PURE__ */ jsx23(GlyphSVG, { ref: glyphRef }) }),
          /* @__PURE__ */ jsx23("div", { className: "v2-marketing-logo-wordmark", children: /* @__PURE__ */ jsx23(WordmarkSVG, { ref: wordmarkRef }) })
        ]
      }
    ),
    /* @__PURE__ */ jsxs8(
      Ariakit.Menu,
      {
        store: menu,
        modal: true,
        getAnchorRect: () => anchorRect,
        className: "v2-marketing-logo-menu",
        children: [
          /* @__PURE__ */ jsxs8(
            Ariakit.MenuItem,
            {
              autoFocus: true,
              onClick: handleDownloadGlyph,
              className: "v2-marketing-logo-menu-item",
              children: [
                /* @__PURE__ */ jsx23("span", { className: "v2-marketing-logo-menu-item-icon", children: /* @__PURE__ */ jsx23(GlyphSVG, {}) }),
                /* @__PURE__ */ jsx23("span", { children: "Download logo glyph as SVG" })
              ]
            }
          ),
          /* @__PURE__ */ jsxs8(
            Ariakit.MenuItem,
            {
              onClick: handleDownloadWordmark,
              className: "v2-marketing-logo-menu-item",
              children: [
                /* @__PURE__ */ jsx23("span", { className: "v2-marketing-logo-menu-item-icon", children: /* @__PURE__ */ jsx23(TextAa, { size: 20 }) }),
                /* @__PURE__ */ jsx23("span", { children: "Download wordmark as SVG" })
              ]
            }
          ),
          /* @__PURE__ */ jsxs8(
            Ariakit.MenuItem,
            {
              className: "v2-marketing-logo-menu-item",
              render: /* @__PURE__ */ jsx23("a", { href: "https://replicate.com/andreasjansson/plasma" }),
              children: [
                /* @__PURE__ */ jsx23("div", { className: "v2-marketing-logo-menu-item-icon v2-marketing-logo-menu-item-icon-gradient", children: /* @__PURE__ */ jsx23("div", { className: "v2-marketing-logo-menu-item-icon-gradient-inner" }) }),
                /* @__PURE__ */ jsx23("span", { children: "Generate your own goo" })
              ]
            }
          )
        ]
      }
    )
  ] });
}

// src/components/site-footer/index.tsx
import { jsx as jsx24, jsxs as jsxs9 } from "react/jsx-runtime";
var productLinks = [
  { label: "Explore", href: "/explore" },
  {
    label: "Playground",
    href: "/playground",
    beta: true
  },
  { label: "Pricing", href: "/pricing" },
  { label: "Docs", href: "/docs" },
  { label: "Blog", href: "/blog" },
  {
    label: "Changelog",
    href: "/changelog"
  }
];
var communityLinks = [
  { label: "Discord", href: "https://discord.gg/replicate" },
  { label: "X", href: "https://x.com/replicate" },
  { label: "GitHub", href: "https://github.com/replicate" }
];
var companyLinks = [
  { label: "Home", href: "/home" },
  { label: "About", href: "/about" },
  { label: "Changelog", href: "/changelog" },
  {
    label: "Join us",
    href: "/about#join-us"
  },
  { label: "Terms", href: "/terms" },
  { label: "Privacy", href: "/privacy" },
  { label: "Status", href: "https://replicatestatus.com/" },
  { label: "Support", href: "/support" }
];
function SiteFooter({
  showBrandFlourish,
  showExpandedFooter,
  platformStatus,
  darkModeToggle,
  renderLink
}) {
  const createLinkRender2 = (link, additionalProps = {}) => {
    const baseProps = __spreadValues({
      href: link.href
    }, additionalProps);
    if (renderLink) {
      return (props) => {
        const _a = props, { key } = _a, propsWithoutKey = __objRest(_a, ["key"]);
        const domSafeProps = Object.fromEntries(
          Object.entries(__spreadValues(__spreadValues({}, baseProps), propsWithoutKey)).filter(
            ([key2]) => !["label", "children"].includes(key2)
          )
        );
        return /* @__PURE__ */ jsx24(React3.Fragment, { children: renderLink(__spreadValues({
          // Metadata (not for spreading)
          href: link.href,
          label: link.label,
          children: propsWithoutKey.children
        }, domSafeProps)) }, key);
      };
    }
    return (props) => {
      const _a = props, { key } = _a, propsWithoutKey = __objRest(_a, ["key"]);
      return /* @__PURE__ */ jsx24("a", __spreadValues(__spreadValues({}, baseProps), propsWithoutKey), key);
    };
  };
  return /* @__PURE__ */ jsxs9(
    "footer",
    {
      className: `site-footer ${showBrandFlourish ? "" : "site-footer--with-border"}`,
      children: [
        showExpandedFooter && showBrandFlourish ? /* @__PURE__ */ jsxs9("div", { "aria-hidden": "true", className: "site-footer-goo-container", children: [
          /* @__PURE__ */ jsx24(Goo, { speed: 0.2, resolution: 2, depth: 5 }),
          /* @__PURE__ */ jsxs9("div", { className: "site-footer-goo-overlay", children: [
            /* @__PURE__ */ jsx24("div", { className: "site-footer-goo-stripe" }),
            /* @__PURE__ */ jsx24("div", { className: "site-footer-goo-stripe" }),
            /* @__PURE__ */ jsx24("div", { className: "site-footer-goo-stripe" })
          ] })
        ] }) : null,
        showExpandedFooter ? /* @__PURE__ */ jsx24("div", { className: "site-footer-expanded", children: /* @__PURE__ */ jsxs9("div", { className: "site-footer-grid", children: [
          /* @__PURE__ */ jsx24("div", { className: "site-footer-logo-section", children: /* @__PURE__ */ jsx24("div", { className: "site-footer-logo", children: /* @__PURE__ */ jsx24(MarketingLogo, {}) }) }),
          /* @__PURE__ */ jsxs9("div", { className: "site-footer-product-section", children: [
            /* @__PURE__ */ jsx24("p", { className: "site-footer-section-title", children: "Product" }),
            /* @__PURE__ */ jsx24("ul", { className: "site-footer-link-list", children: productLinks.map((link) => {
              const LinkComponent = createLinkRender2(link, { className: "site-footer-link group" });
              return /* @__PURE__ */ jsx24("li", { children: /* @__PURE__ */ jsxs9(LinkComponent, { children: [
                /* @__PURE__ */ jsx24("span", { className: "site-footer-link-text", children: link.label }),
                "beta" in link && link.beta ? /* @__PURE__ */ jsxs9("span", { className: "site-footer-beta-badge", children: [
                  " ",
                  "(beta)"
                ] }) : null
              ] }) }, link.label);
            }) })
          ] }),
          /* @__PURE__ */ jsxs9("div", { children: [
            /* @__PURE__ */ jsx24("p", { className: "site-footer-section-title", children: "Community" }),
            /* @__PURE__ */ jsx24("ul", { className: "site-footer-link-list", children: communityLinks.map((link) => {
              const LinkComponent = createLinkRender2(link, { className: "site-footer-link--simple" });
              return /* @__PURE__ */ jsx24("li", { children: /* @__PURE__ */ jsx24(LinkComponent, { children: link.label }) }, link.label);
            }) })
          ] }),
          /* @__PURE__ */ jsxs9("div", { children: [
            /* @__PURE__ */ jsx24("p", { className: "site-footer-section-title", children: "Company" }),
            /* @__PURE__ */ jsx24("ul", { className: "site-footer-link-list", children: companyLinks.map((link) => {
              const LinkComponent = createLinkRender2(link, { className: "site-footer-link--simple" });
              return /* @__PURE__ */ jsx24("li", { children: /* @__PURE__ */ jsx24(LinkComponent, { children: link.label }) }, link.label);
            }) })
          ] })
        ] }) }) : null,
        /* @__PURE__ */ jsx24("div", { className: "site-footer-bottom", children: /* @__PURE__ */ jsxs9("div", { className: "site-footer-bottom-container", children: [
          /* @__PURE__ */ jsx24("div", { className: "site-footer-platform-status", children: platformStatus }),
          /* @__PURE__ */ jsxs9(
            "div",
            {
              className: `site-footer-bottom-content ${!showExpandedFooter ? "site-footer-bottom-content--full-width" : ""}`,
              children: [
                !showExpandedFooter ? /* @__PURE__ */ jsx24("ul", { children: companyLinks.map((link) => {
                  const LinkComponent = createLinkRender2(link, { className: "site-footer-bottom-link-text" });
                  return /* @__PURE__ */ jsx24("li", { className: "site-footer-bottom-link", children: /* @__PURE__ */ jsx24(LinkComponent, { children: link.label }) }, link.label);
                }) }) : null,
                /* @__PURE__ */ jsx24("div", { className: "site-footer-dark-mode-toggle", children: darkModeToggle })
              ]
            }
          )
        ] }) })
      ]
    }
  );
}

// src/components/site-navigation-dropdown/index.tsx
import * as Ariakit2 from "@ariakit/react";
import { CaretDown as CaretDown3 } from "@phosphor-icons/react/dist/ssr";
import { jsx as jsx25, jsxs as jsxs10 } from "react/jsx-runtime";
function SiteNavigationDropdown({
  currentPath,
  items = [],
  anchorProps = () => ({}),
  buttonVariant = "outlined",
  buttonSize = "md",
  triggerText = "Dashboard",
  iconOnly = false
}) {
  const menuStore = Ariakit2.useMenuStore();
  return /* @__PURE__ */ jsxs10(Ariakit2.MenuProvider, { timeout: 0, placement: "bottom", store: menuStore, children: [
    /* @__PURE__ */ jsx25(
      Ariakit2.MenuButton,
      {
        render: iconOnly ? /* @__PURE__ */ jsx25(IconButton, { variant: buttonVariant, size: buttonSize, children: /* @__PURE__ */ jsx25(CaretDown3, {}) }) : /* @__PURE__ */ jsx25(
          Button,
          {
            variant: buttonVariant,
            size: buttonSize,
            endIcon: /* @__PURE__ */ jsx25(CaretDown3, { weight: "bold" })
          }
        ),
        children: iconOnly ? null : triggerText
      }
    ),
    /* @__PURE__ */ jsx25(
      Ariakit2.Menu,
      {
        hideOnHoverOutside: true,
        focusable: false,
        unmountOnHide: true,
        className: "v2-dropdown-menu v2-dropdown-menu--dashboard",
        children: items.map((item) => /* @__PURE__ */ jsxs10(
          Ariakit2.MenuItem,
          {
            tabbable: true,
            focusOnHover: false,
            blurOnHoverEnd: true,
            className: "v2-dropdown-menu-item",
            render: /* @__PURE__ */ jsx25(
              "a",
              __spreadValues({
                "data-active": isItemActive(item, currentPath),
                href: item.href
              }, anchorProps(item))
            ),
            children: [
              /* @__PURE__ */ jsx25("span", { className: "v2-dropdown-menu-item--icon", children: item.icon }),
              /* @__PURE__ */ jsxs10("div", { children: [
                /* @__PURE__ */ jsx25("div", { className: "v2-dropdown-menu-item--label", children: item.label }),
                /* @__PURE__ */ jsx25("div", { className: "v2-dropdown-menu-item--description", children: item.description })
              ] })
            ]
          },
          item.label
        ))
      }
    )
  ] });
}

// src/components/search/index.tsx
import { ComboboxItem as ComboboxItem5 } from "@ariakit/react";
import {
  Cube as Cube2,
  CurrencyDollar,
  GraduationCap as GraduationCap3,
  GridNine as GridNine2,
  Lifebuoy,
  Password,
  Plus as Plus3,
  RocketLaunch,
  Sparkle as Sparkle2
} from "@phosphor-icons/react";
import { useId, useMemo as useMemo5, useState as useState5 } from "react";

// src/components/search/item.tsx
import { forwardRef as forwardRef9, useMemo as useMemo3 } from "react";
import { SealCheck, SquaresFour } from "@phosphor-icons/react/dist/ssr";

// src/cover-image.ts
import mime from "mime";
function parseCoverImageUrl({
  url
}) {
  if (!url) return null;
  const mimeType = mime.getType(url);
  if (!mimeType) return null;
  if (mimeType.startsWith("video/")) {
    return { fileType: "video", url };
  }
  if (mimeType.startsWith("image/")) {
    return { fileType: "image", url };
  }
  return null;
}

// src/components/search/item.tsx
import { Fragment as Fragment2, jsx as jsx26, jsxs as jsxs11 } from "react/jsx-runtime";
var SearchPageResultItem = forwardRef9((_a, ref) => {
  var _b = _a, { children, href, icon } = _b, rest = __objRest(_b, ["children", "href", "icon"]);
  const IconEl = icon ? icon : () => null;
  return /* @__PURE__ */ jsx26("a", __spreadProps(__spreadValues({ ref, href, className: "r8-search-page-item group" }, rest), { children: /* @__PURE__ */ jsx26("div", { className: "r8-search-page-item-container", children: /* @__PURE__ */ jsxs11("div", { className: "r8-search-page-item-content", children: [
    /* @__PURE__ */ jsx26("div", { className: "r8-search-page-item-icon", children: /* @__PURE__ */ jsx26(IconEl, { size: 20 }) }),
    /* @__PURE__ */ jsx26("span", { className: "r8-search-page-item-text", children })
  ] }) }) }));
});
var CollectionSearchResultItem = forwardRef9((_a, ref) => {
  var _b = _a, { collection } = _b, rest = __objRest(_b, ["collection"]);
  const collectionRoute = `/collections/${collection.slug}`;
  return /* @__PURE__ */ jsx26(
    "a",
    __spreadProps(__spreadValues({
      ref,
      href: collectionRoute,
      className: "r8-search-collection-item group"
    }, rest), {
      children: /* @__PURE__ */ jsxs11("div", { className: "r8-search-collection-item-content", children: [
        /* @__PURE__ */ jsx26("div", { className: "r8-search-collection-item-icon", children: /* @__PURE__ */ jsx26(SquaresFour, { className: "text-r8-gray-11", size: 20, weight: "fill" }) }),
        /* @__PURE__ */ jsx26("span", { className: "r8-search-collection-item-text", children: collection.name })
      ] })
    })
  );
});
var ModelSearchResultItem = forwardRef9((_a, ref) => {
  var _b = _a, { result, condensed } = _b, rest = __objRest(_b, ["result", "condensed"]);
  const parsedCoverImage = parseCoverImageUrl({ url: result.model.cover_image_url });
  const coverImageElement = useMemo3(() => {
    if (!parsedCoverImage)
      return /* @__PURE__ */ jsx26("div", { className: "r8-search-model-cover-placeholder" });
    if (parsedCoverImage.fileType === "image") {
      return /* @__PURE__ */ jsx26("img", { src: parsedCoverImage.url, alt: `Cover for ${result.model.name}` });
    }
    if (parsedCoverImage.fileType === "video") {
      return /* @__PURE__ */ jsx26(
        "video",
        {
          controls: false,
          autoPlay: true,
          muted: true,
          loop: true,
          playsInline: true,
          className: "r8-search-model-cover-video",
          children: /* @__PURE__ */ jsx26("source", { src: parsedCoverImage.url })
        }
      );
    }
    return /* @__PURE__ */ jsx26("div", { className: "r8-search-model-cover-placeholder" });
  }, [parsedCoverImage, result.model.name]);
  return /* @__PURE__ */ jsxs11(
    "a",
    __spreadProps(__spreadValues({
      ref,
      href: `/${result.model.owner}/${result.model.name}`,
      className: "r8-search-model-item group"
    }, rest), {
      children: [
        /* @__PURE__ */ jsx26("div", { className: "r8-search-model-cover", children: coverImageElement }),
        /* @__PURE__ */ jsxs11("div", { className: "r8-search-model-item-container", children: [
          /* @__PURE__ */ jsxs11("div", { className: "r8-search-model-item-header", children: [
            /* @__PURE__ */ jsxs11(
              "div",
              {
                className: `r8-search-model-item-title ${condensed ? "r8-search-model-item-title--condensed" : "r8-search-model-item-title--normal"}`,
                children: [
                  /* @__PURE__ */ jsx26("span", { className: "r8-search-model-username", children: result.model.owner }),
                  /* @__PURE__ */ jsx26("span", { className: "r8-search-model-separator", children: "\u2009/\u2009" }),
                  /* @__PURE__ */ jsx26("span", { className: "r8-search-model-name", children: result.model.name }),
                  result.metadata.is_official ? /* @__PURE__ */ jsxs11(Fragment2, { children: [
                    " ",
                    /* @__PURE__ */ jsx26(SealCheck, { weight: "fill", className: "r8-search-model-verified" })
                  ] }) : null
                ]
              }
            ),
            result.metadata.aa_rank && result.metadata.aa_category ? /* @__PURE__ */ jsxs11(
              "span",
              {
                className: `r8-search-model-aa-rank r8-search-model-aa-rank--${result.metadata.aa_rank}`,
                children: [
                  "#",
                  result.metadata.aa_rank,
                  " in ",
                  result.metadata.aa_category
                ]
              }
            ) : null,
            /* @__PURE__ */ jsxs11("span", { className: "r8-search-model-runs", children: [
              compactInteger(result.model.run_count),
              " runs"
            ] })
          ] }),
          result.model.description && /* @__PURE__ */ jsx26("p", { className: "r8-search-model-description", children: result.model.description })
        ] })
      ]
    })
  );
});

// src/components/search/hooks.ts
import { useDebounce, useRequest } from "ahooks";
import { useEffect as useEffect4, useMemo as useMemo4, useState as useState4 } from "react";
function fetchSearchResults(_0) {
  return __async(this, arguments, function* ({
    query,
    params
  }) {
    const url = new URL(
      "https://replicate-search-prototype-production.replicate.workers.dev/query"
    );
    url.searchParams.set("q", query);
    url.searchParams.set("limit", String(params.limit));
    const res = yield fetch(url);
    if (!res.ok) {
      throw new Error(
        `Failed to fetch search prototype results: ${res.statusText}`
      );
    }
    return yield res.json();
  });
}
function useSearchApi({
  query,
  debounceMs = 300,
  params
}) {
  const debouncedSearchQuery = useDebounce(query || "", {
    wait: debounceMs
  });
  const { loading, error, data, mutate } = useRequest(
    () => fetchSearchResults({ query: debouncedSearchQuery, params }),
    {
      manual: false,
      ready: Boolean(debouncedSearchQuery),
      refreshDeps: [debouncedSearchQuery],
      refreshOnWindowFocus: false,
      staleTime: 0
    }
  );
  return {
    loading,
    data,
    error,
    clear: () => mutate(void 0)
  };
}
function useMediaMatch(query) {
  const [matches, setMatches] = useState4(false);
  const matchMedia = useMemo4(() => {
    if (typeof window === "undefined") {
      return null;
    }
    return window.matchMedia(query);
  }, [query]);
  useEffect4(() => {
    if (!matchMedia) {
      return;
    }
    setMatches(matchMedia.matches);
    const listener = (event) => setMatches(event.matches);
    if (matchMedia.addEventListener) {
      matchMedia.addEventListener("change", listener);
      return () => matchMedia.removeEventListener("change", listener);
    }
    matchMedia.addListener(listener);
    return () => matchMedia.removeListener(listener);
  }, [matchMedia]);
  return matches;
}
function useIsClient() {
  const [isClient, setClient] = useState4(false);
  useEffect4(() => {
    setClient(true);
  }, []);
  return isClient;
}

// src/components/search/combobox.tsx
import * as Ariakit3 from "@ariakit/react";
import {
  ArrowDown,
  ArrowLeft,
  ArrowRight,
  ArrowUp,
  KeyReturn,
  MagnifyingGlass
} from "@phosphor-icons/react";
import { useKeyPress } from "ahooks";
import clsx3 from "clsx";
import * as React4 from "react";
import { isMacOs } from "react-device-detect";

// src/components/search/logos/aa-logo.tsx
import { jsx as jsx27, jsxs as jsxs12 } from "react/jsx-runtime";
function ArtificalAnalysisLogo({ className }) {
  return /* @__PURE__ */ jsxs12(
    "svg",
    {
      width: "32",
      height: "32",
      viewBox: "0 0 32 32",
      xmlns: "http://www.w3.org/2000/svg",
      className,
      children: [
        /* @__PURE__ */ jsx27(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M24.672 26.8826H30.089L22.9351 14.4346L20.21 19.1539C21.6973 21.7306 23.1847 24.3059 24.672 26.8826Z"
          }
        ),
        /* @__PURE__ */ jsx27(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M13.2888 7.16416L15.9973 2.47424L22.6059 13.9213L21.413 15.959L19.8783 18.5779L18.3448 15.9232L13.2888 7.16416Z"
          }
        ),
        /* @__PURE__ */ jsx27(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M15.6686 12.4262L12.9639 7.72736L1.91113 26.8723H7.32809C17.4273 9.37984 9.22121 23.593 15.6686 12.4262Z"
          }
        ),
        /* @__PURE__ */ jsx27(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M22.5945 24.407L19.886 19.7158L15.749 26.8826H21.1647L22.5945 24.407Z"
          }
        )
      ]
    }
  );
}

// src/components/search/combobox.tsx
import { jsx as jsx28, jsxs as jsxs13 } from "react/jsx-runtime";
function ComboboxProvider3(_a) {
  var _b = _a, {
    tabId,
    setTabId,
    defaultTabId,
    onSearch,
    onTabChange
  } = _b, props = __objRest(_b, [
    "tabId",
    "setTabId",
    "defaultTabId",
    "onSearch",
    "onTabChange"
  ]);
  return /* @__PURE__ */ jsx28(
    Ariakit3.ComboboxProvider,
    __spreadProps(__spreadValues({}, props), {
      setValue: (value) => {
        var _a2;
        (_a2 = props.setValue) == null ? void 0 : _a2.call(props, value);
        React4.startTransition(() => {
          onSearch == null ? void 0 : onSearch(value);
        });
      },
      children: /* @__PURE__ */ jsx28(
        TabProvider,
        {
          selectedId: tabId,
          defaultSelectedId: defaultTabId,
          setSelectedId: (id) => {
            if (!id) return;
            setTabId == null ? void 0 : setTabId(id);
            React4.startTransition(() => {
              onTabChange == null ? void 0 : onTabChange(id);
            });
          },
          children: props.children
        }
      )
    })
  );
}
var Combobox3 = React4.forwardRef(function Combobox4(_a, ref) {
  var _b = _a, { loading } = _b, rest = __objRest(_b, ["loading"]);
  const combobox = Ariakit3.useComboboxContext();
  const isOpen = Ariakit3.useStoreState(combobox, "open");
  const isClient = useIsClient();
  useKeyPress(["meta.k"], (e) => {
    e.preventDefault();
    if (!combobox) return;
    combobox.toggle();
    combobox.move(null);
  });
  return /* @__PURE__ */ jsxs13("div", { className: "combobox-wrapper r8-search-combobox-wrapper", children: [
    /* @__PURE__ */ jsx28("div", { className: "r8-search-combobox-icon-left", children: /* @__PURE__ */ jsx28(MagnifyingGlass, { size: 15 }) }),
    /* @__PURE__ */ jsx28(
      Ariakit3.Combobox,
      __spreadProps(__spreadValues({
        ref,
        autoSelect: true,
        autoFocus: false,
        autoComplete: "none",
        autoCorrect: "off",
        autoCapitalize: "off",
        spellCheck: "false",
        maxLength: 100
      }, rest), {
        className: clsx3("combobox", rest.className)
      })
    ),
    /* @__PURE__ */ jsxs13("div", { className: "r8-search-combobox-icon-right", children: [
      loading && isOpen ? /* @__PURE__ */ jsx28("div", { className: "r8-search-combobox-spinner", children: /* @__PURE__ */ jsx28(Spinner, {}) }) : null,
      !isOpen && isClient ? /* @__PURE__ */ jsx28("div", { className: "r8-search-combobox-kbd-hint", children: /* @__PURE__ */ jsx28(ClientSideKeyboardIndicator, {}) }) : null
    ] })
  ] });
});
function ClientSideKeyboardIndicator() {
  return /* @__PURE__ */ jsxs13("kbd", { className: "r8-search-combobox-kbd", children: [
    isMacOs ? "cmd" : "ctrl",
    "+k"
  ] });
}
var ComboboxPopover3 = React4.forwardRef(function ComboboxPopover4(props, ref) {
  const isDesktop = useMediaMatch("(min-width: 1024px)");
  const combobox = Ariakit3.useComboboxContext();
  const isInputActive = Ariakit3.useStoreState(
    combobox,
    (state) => (state == null ? void 0 : state.activeId) === null
  );
  const mounted = React4.useDeferredValue(
    Ariakit3.useStoreState(combobox, "mounted")
  );
  return /* @__PURE__ */ jsxs13(
    Ariakit3.ComboboxPopover,
    __spreadProps(__spreadValues({
      ref,
      gutter: 8,
      unmountOnHide: true,
      fitViewport: true,
      sameWidth: isDesktop,
      autoFocusOnHide: false,
      className: "r8-search-combobox-popover",
      wrapperProps: {
        style: {
          width: "100%"
        }
      },
      hidden: !mounted
    }, props), {
      children: [
        mounted && props.children,
        /* @__PURE__ */ jsxs13("div", { className: "r8-search-combobox-footer", children: [
          /* @__PURE__ */ jsxs13("div", { className: "r8-search-combobox-footer-shortcuts", children: [
            /* @__PURE__ */ jsxs13("div", { className: "r8-search-combobox-shortcut", children: [
              /* @__PURE__ */ jsxs13("div", { className: "r8-search-combobox-shortcut-icon", children: [
                /* @__PURE__ */ jsx28("kbd", { className: "kbd", "aria-label": "Up Arrow", children: /* @__PURE__ */ jsx28(ArrowUp, {}) }),
                /* @__PURE__ */ jsx28("kbd", { className: "kbd", "aria-label": "Down Arrow", children: /* @__PURE__ */ jsx28(ArrowDown, {}) })
              ] }),
              /* @__PURE__ */ jsx28("span", { className: "r8-search-combobox-shortcut-text", children: "to navigate" })
            ] }),
            !isInputActive && /* @__PURE__ */ jsxs13("div", { className: "r8-search-combobox-shortcut", children: [
              /* @__PURE__ */ jsxs13("div", { className: "r8-search-combobox-shortcut-icon", children: [
                /* @__PURE__ */ jsx28("kbd", { className: "kbd", "aria-label": "Left Arrow", children: /* @__PURE__ */ jsx28(ArrowLeft, {}) }),
                /* @__PURE__ */ jsx28("kbd", { className: "kbd", "aria-label": "Right Arrow", children: /* @__PURE__ */ jsx28(ArrowRight, {}) })
              ] }),
              /* @__PURE__ */ jsx28("span", { className: "r8-search-combobox-shortcut-text", children: "to switch tabs" })
            ] }),
            !isInputActive && /* @__PURE__ */ jsxs13("div", { className: "r8-search-combobox-shortcut", children: [
              /* @__PURE__ */ jsx28("div", { className: "r8-search-combobox-shortcut-icon", children: /* @__PURE__ */ jsx28("kbd", { className: "kbd", "aria-label": "Enter", children: /* @__PURE__ */ jsx28(KeyReturn, {}) }) }),
              /* @__PURE__ */ jsx28("span", { className: "r8-search-combobox-shortcut-text", children: "to select" })
            ] })
          ] }),
          /* @__PURE__ */ jsxs13("div", { className: "r8-search-combobox-footer-powered-by", children: [
            /* @__PURE__ */ jsx28(ArtificalAnalysisLogo, { className: "r8-search-combobox-footer-powered-by-logo" }),
            /* @__PURE__ */ jsx28("span", { children: "Powered by Artificial Analysis" })
          ] })
        ] })
      ]
    })
  );
});
var ComboboxTabList = React4.forwardRef(function ComboboxTabList2(props, ref) {
  return /* @__PURE__ */ jsx28(
    TabList,
    __spreadProps(__spreadValues({
      ref
    }, props), {
      size: "sm",
      className: clsx3("r8-search-combobox-tab-list", props.className)
    })
  );
});
var ComboboxTab = React4.forwardRef(function ComboboxTab2(props, ref) {
  return /* @__PURE__ */ jsx28(
    Tab,
    __spreadProps(__spreadValues({
      ref,
      accessibleWhenDisabled: false
    }, props), {
      className: clsx3("tab", props.className)
    })
  );
});
var ComboboxPanel = React4.forwardRef(function ComboboxTabPanel(props, ref) {
  const tab = Ariakit3.useTabContext();
  const tabId = Ariakit3.useStoreState(
    tab,
    (state) => {
      var _a;
      return (_a = props.tabId) != null ? _a : state == null ? void 0 : state.selectedId;
    }
  );
  return /* @__PURE__ */ jsx28(
    TabPanel,
    __spreadProps(__spreadValues({
      ref,
      tabId
    }, props), {
      className: clsx3("tab-panel", props.className),
      children: /* @__PURE__ */ jsx28(Ariakit3.ComboboxList, { className: "listbox", children: props.children })
    })
  );
});
var ComboboxItem3 = React4.forwardRef(
  function ComboboxItem4(props, ref) {
    return /* @__PURE__ */ jsx28(
      Ariakit3.ComboboxItem,
      __spreadProps(__spreadValues({
        ref,
        focusOnHover: true,
        blurOnHoverEnd: false
      }, props), {
        className: clsx3("combobox-item", props.className)
      })
    );
  }
);

// src/components/search/index.tsx
import {
  Article,
  BookOpenText,
  ListMagnifyingGlass,
  NewspaperClipping
} from "@phosphor-icons/react/dist/ssr";
import { jsx as jsx29, jsxs as jsxs14 } from "react/jsx-runtime";
function getTabId(category, prefix) {
  return `${prefix}/${category}`;
}
function getCategory(tabId, prefix) {
  return tabId.replace(`${prefix}/`, "");
}
function groupBy(array, key) {
  return array.reduce(
    (acc, item) => {
      const groupKey = String(item[key]);
      if (!acc[groupKey]) {
        acc[groupKey] = [];
      }
      acc[groupKey].push(item);
      return acc;
    },
    {}
  );
}
var unAuthedPages = {
  "/playground": {
    name: "Playground (beta)",
    href: "/playground",
    icon: GridNine2
  },
  "/docs": {
    name: "Docs",
    href: "/docs",
    icon: BookOpenText
  },
  "/blog": {
    name: "Blog",
    href: "/blog",
    icon: Article
  },
  "/changelog": {
    name: "Changelog",
    href: "/changelog",
    icon: NewspaperClipping
  }
};
var authedPages = {
  "/models": {
    name: "Models",
    href: "/models",
    icon: Cube2
  },
  "/predictions": {
    name: "Predictions",
    href: "/predictions",
    icon: Sparkle2
  },
  "/trainings": {
    name: "Trainings",
    href: "/trainings",
    icon: GraduationCap3
  },
  "/deployments": {
    name: "Deployments",
    href: "/deployments",
    icon: RocketLaunch
  },
  "/account/billing": {
    name: "Billing",
    href: "/account/billing",
    icon: CurrencyDollar
  },
  "/support": {
    name: "Support",
    href: "/support",
    icon: Lifebuoy
  },
  "/account/api-tokens": {
    name: "API Tokens",
    href: "/account/api-tokens",
    icon: Password
  },
  "/create": {
    name: "Create model",
    href: "/create",
    icon: Plus3
  }
};
var categories = ["All", "Models", "Collections", "Pages"];
function Search({
  authState,
  params = {
    limit: 50
  }
}) {
  const prefix = useId();
  const [searchValue, setSearchValue] = useState5("");
  const [tabId, setTabId] = useState5(getTabId("All", prefix));
  const searchResults = useSearchApi({
    query: searchValue,
    params
  });
  const isLoading = searchResults.loading;
  const modelResults = useMemo5(() => {
    if (!searchResults.data) {
      return [];
    }
    return searchResults.data.results;
  }, [searchResults]);
  const collectionResults = useMemo5(() => {
    if (!searchResults.data) {
      return [];
    }
    return searchResults.data.metadata.collections;
  }, [searchResults]);
  const pageResults = useMemo5(() => {
    const mapApiPageToDisplayPage = (apiPage) => {
      const pageConfig = authState === "authenticated" ? __spreadValues(__spreadValues({}, unAuthedPages), authedPages)[apiPage.href] : unAuthedPages[apiPage.href];
      return {
        name: (pageConfig == null ? void 0 : pageConfig.name) || apiPage.name,
        href: apiPage.href,
        icon: (pageConfig == null ? void 0 : pageConfig.icon) || GridNine2
      };
    };
    if (!searchResults.data) {
      return authState === "authenticated" ? Object.values(authedPages) : Object.values(unAuthedPages);
    }
    const unauthedPageResults = searchResults.data.metadata.pages.filter((page) => Object.keys(unAuthedPages).includes(page.href)).map(mapApiPageToDisplayPage);
    const authedPageResults = searchResults.data.metadata.pages.filter((page) => Object.keys(authedPages).includes(page.href)).map(mapApiPageToDisplayPage);
    const pages = authState === "authenticated" ? [...unauthedPageResults, ...authedPageResults] : [...unauthedPageResults];
    return pages;
  }, [searchResults, authState]);
  const matches = useMemo5(() => {
    const pageItems = pageResults.map((item) => __spreadProps(__spreadValues({}, item), {
      category: "Pages",
      type: "page"
    }));
    const modelItems = modelResults.map((item) => __spreadProps(__spreadValues({}, item), {
      category: "Models",
      type: "model"
    }));
    const collectionItems = collectionResults.map(
      (item) => __spreadProps(__spreadValues({}, item), {
        category: "Collections",
        type: "collection"
      })
    );
    const allResults = [
      ...pageItems,
      ...modelItems,
      ...collectionItems
    ];
    const groups = groupBy(allResults, "category");
    groups.All = allResults;
    groups.Models = groups.Models || [];
    groups.Collections = groups.Collections || [];
    groups.Pages = groups.Pages || [];
    return groups;
  }, [modelResults, collectionResults, pageResults]);
  const currentPages = matches[getCategory(tabId, prefix)] || [];
  return /* @__PURE__ */ jsxs14(
    ComboboxProvider3,
    {
      defaultTabId: tabId,
      onTabChange: setTabId,
      onSearch: setSearchValue,
      resetValueOnHide: true,
      setOpen: (open) => {
        if (!open) {
          searchResults.clear();
        }
      },
      children: [
        /* @__PURE__ */ jsx29(
          Combobox3,
          {
            className: "r8-search-combobox",
            placeholder: "Search 'best image models' or 'text to image'",
            loading: isLoading && Boolean(searchValue)
          }
        ),
        /* @__PURE__ */ jsxs14(ComboboxPopover3, { "aria-label": "Pages", children: [
          /* @__PURE__ */ jsx29(ComboboxTabList, { "aria-label": "Categories", children: categories.map((category) => {
            const currentPages2 = matches[category];
            return /* @__PURE__ */ jsx29(
              ComboboxTab,
              {
                id: getTabId(category, prefix),
                disabled: !(currentPages2 == null ? void 0 : currentPages2.length),
                children: /* @__PURE__ */ jsxs14("div", { className: "r8-search-tab-content", children: [
                  /* @__PURE__ */ jsx29("span", { children: category }),
                  /* @__PURE__ */ jsx29("div", { children: /* @__PURE__ */ jsx29(Badge, { rounded: true, size: "sm", children: (currentPages2 == null ? void 0 : currentPages2.length) || 0 }) })
                ] })
              },
              category
            );
          }) }),
          /* @__PURE__ */ jsxs14(ComboboxPanel, { children: [
            searchValue && isLoading ? /* @__PURE__ */ jsxs14("div", { className: "r8-search-loading", children: [
              /* @__PURE__ */ jsx29(GlyphLoader, {}),
              /* @__PURE__ */ jsx29("p", { className: "r8-search-loading-text", children: "Searching..." })
            ] }) : null,
            searchValue ? /* @__PURE__ */ jsx29(
              ComboboxItem5,
              {
                render: /* @__PURE__ */ jsxs14(
                  SearchPageResultItem,
                  {
                    icon: ListMagnifyingGlass,
                    href: `/search?query=${encodeURIComponent(searchValue)}`,
                    children: [
                      "View all results for",
                      " ",
                      /* @__PURE__ */ jsx29("span", { className: "font-semibold", children: searchValue })
                    ]
                  }
                )
              },
              "search-page"
            ) : null,
            currentPages.map((item, i) => {
              switch (item.type) {
                case "model":
                  return /* @__PURE__ */ jsx29(
                    ComboboxItem5,
                    {
                      render: /* @__PURE__ */ jsx29(ModelSearchResultItem, { condensed: true, result: item })
                    },
                    `${item.model.owner}-${item.model.name}-${i}`
                  );
                case "collection":
                  return /* @__PURE__ */ jsx29(
                    ComboboxItem5,
                    {
                      render: /* @__PURE__ */ jsx29(CollectionSearchResultItem, { collection: item })
                    },
                    `${item.slug}-${i}`
                  );
                case "page":
                  return /* @__PURE__ */ jsx29(
                    ComboboxItem5,
                    {
                      render: /* @__PURE__ */ jsx29(SearchPageResultItem, { icon: item.icon, href: item.href, children: item.name })
                    },
                    `${item.href}-${i}`
                  );
                default:
                  return null;
              }
            })
          ] })
        ] })
      ]
    }
  );
}

// src/components/platform-status-badge/index.tsx
import { jsx as jsx30, jsxs as jsxs15 } from "react/jsx-runtime";
function PlatformStatusBadge({
  status,
  url = "https://statuspage.incident.io/replicate"
}) {
  return /* @__PURE__ */ jsx30("div", { children: /* @__PURE__ */ jsxs15(
    "a",
    {
      href: url,
      className: "r8-platform-status-badge",
      "data-status": status,
      target: "_blank",
      rel: "noreferrer",
      children: [
        /* @__PURE__ */ jsx30("div", { className: "r8-platform-status-badge--indicator" }),
        /* @__PURE__ */ jsx30("div", { className: "r8-platform-status-badge--label", children: /* @__PURE__ */ jsx30("span", { children: status === "healthy" ? "All services are online" : "Some services may be impacted" }) })
      ]
    }
  ) });
}

// src/index.ts
import { VisuallyHidden, Group, GroupLabel, Command } from "@ariakit/react";
export {
  Avatar,
  Badge,
  Banner,
  Box,
  Button,
  Checkbox,
  CheckboxProvider,
  Combobox,
  ComboboxGroup,
  ComboboxGroupLabel,
  ComboboxItem,
  ComboboxLabel,
  ComboboxList,
  ComboboxPopover,
  ComboboxProvider,
  Command,
  DashboardNavigation,
  DashboardTabList,
  Dialog,
  DialogDescription,
  DialogDisclosure,
  DialogDismiss,
  DialogHeading,
  DialogProvider,
  Disclosure,
  DisclosureContent,
  DisclosureProvider,
  FormGroup,
  GlyphLoader,
  Goo,
  Group,
  GroupLabel,
  IconButton,
  Label,
  Logo,
  MarketingLogo,
  Menu,
  MenuButton,
  MenuGroup,
  MenuGroupLabel,
  MenuItem,
  MenuItemCheck,
  MenuItemCheckbox,
  MenuItemRadio,
  MenuList,
  MenuProvider,
  MenuSeparator,
  NativeSelect,
  PlatformStatusBadge,
  Popover,
  PopoverAnchor,
  PopoverArrow,
  PopoverDescription,
  PopoverDisclosure,
  PopoverDismiss,
  PopoverHeading,
  PopoverProvider,
  Radio,
  RadioGroup,
  RadioProvider,
  Search,
  Select,
  SelectGroup,
  SelectGroupLabel,
  SelectItem,
  SelectItemCheck,
  SelectLabel,
  SelectList,
  SelectPopover,
  SelectProvider,
  SelectRow,
  DashboardLinks as SiteDashboardLinks,
  SiteFooter,
  SiteNavigation,
  SiteNavigationDropdown,
  Links as SiteNavigationLinks,
  Spinner,
  Tab,
  TabList,
  TabPanel,
  TabProvider,
  TextField,
  Textarea,
  Tooltip,
  TooltipAnchor,
  TooltipArrow,
  TooltipProvider,
  VisuallyHidden,
  badge,
  banner,
  box,
  compactInteger,
  createMenu,
  dialog,
  exploreMenu,
  formGroup,
  parseCoverImageUrl,
  selectItem,
  tabs,
  useCheckboxContext,
  useCheckboxStore,
  useComboboxContext,
  useComboboxStore,
  useDialogContext,
  useDialogStore,
  useDisclosureContext,
  useDisclosureStore,
  useMenuContext,
  useMenuStore,
  usePopoverContext,
  usePopoverStore,
  useRadioContext,
  useRadioStore,
  useSelectContext,
  useSelectStore,
  useTabContext,
  useTabStore,
  useTooltipStore
};
//# sourceMappingURL=index.mjs.map